import React, { createContext, useContext, useEffect, useState } from "react";

const translations = {
  ar: {
    // Common
    app_title: "Barn's Tracker",
    app_subtitle: "إدارة عمليات الموظفين والفروع",
    loading: "جاري التحميل...",
    save: "حفظ",
    saving: "جاري الحفظ...",
    cancel: "إلغاء",
    edit: "تعديل",
    delete: "حذف",
    actions: "إجراءات",
    confirm_delete: "هل أنت متأكد من الحذف؟",
    no_results: "لا توجد نتائج مطابقة.",
    total: "إجمالي",
    yes: "نعم",
    no: "لا",

    // Login & Auth
    login_subtitle: "سجل الدخول بحسابك للمتابعة",
    username: "اسم المستخدم أو البريد",
    username_placeholder: "اسم المستخدم أو البريد الإلكتروني",
    password: "كلمة المرور",
    login: "دخول",
    logging_in: "جارٍ الدخول...",
    login_error_generic: "حدث خطأ. حاول مرة أخرى",
    no_account: "ما عندك حساب؟",
    have_account: "عندك حساب؟",
    create_account: "أنشئ حساباً",
    create_account_title: "تسجيل حساب مدير منطقة",
    create_account_subtitle: "أنشئ حسابك للوصول إلى لوحة الإدارة الخاصة بك",
    register_error_generic: "حدث خطأ أثناء التسجيل. حاول مرة أخرى",
    show_password: "عرض كلمة المرور",
    hide_password: "إخفاء كلمة المرور",
    forgot_password: "نسيت كلمة المرور؟",
    remember_username: "تذكر اسم المستخدم",
    forgot_password_title: "نسيت كلمة المرور؟",
    forgot_password_subtitle: "أدخل اسم المستخدم أو البريد لإرسال رابط إعادة التعيين",
    forgot_identifier_label: "اسم المستخدم أو البريد الإلكتروني",
    forgot_identifier_placeholder: "username أو name@example.com",
    send_reset_link: "إرسال رابط إعادة التعيين",
    forgot_sent_title: "تم إرسال الرابط ✓",
    forgot_sent_msg: "إذا كان الحساب موجوداً، ستصلك رسالة على بريدك — وعلى تيليجرام أيضاً إذا كان حسابك مرتبطاً بالبوت. الرابط صالح لمدة ساعة واحدة.",
    reset_password_title: "إعادة تعيين كلمة المرور",
    reset_password_subtitle: "اختر كلمة مرور جديدة قوية",
    register_success_title: "تم إنشاء الحساب بنجاح",
    register_pending_title: "حسابك قيد المراجعة",
    register_pending_msg: "تم إرسال طلبك إلى الإدارة لاعتماده. سيتم إعلامك على بريدك بمجرد تفعيل حسابك ثم تستطيع تسجيل الدخول.",
    pending_approval_badge: "قيد المراجعة",
    approve: "اعتماد",
    approve_account: "اعتماد الحساب",
    approving: "جارٍ الاعتماد...",
    approved_success: "تم اعتماد الحساب بنجاح ✅",
    approved_already: "هذا الحساب مفعّل مسبقاً",
    approve_failed: "فشل اعتماد الحساب",
    approve_back_to_login: "العودة لتسجيل الدخول",
    register_success_email_sent: "تم إرسال رسالة تأكيد إلى {email}. افتح الرسالة واضغط على رابط التفعيل.",
    register_success_no_email: "تم إنشاء الحساب. تواصل مع المالك لتفعيل البريد الإلكتروني.",
    redirecting: "جاري التحويل",
    full_name: "الاسم الكامل",
    full_name_placeholder: "اسمك الكامل",
    username_hint: "أحرف إنجليزية وأرقام و . _ - فقط (3 أحرف فأكثر)",
    email: "البريد الإلكتروني",
    password_confirm: "تأكيد كلمة المرور",
    pw_check_length: "٨ أحرف فأكثر",
    pw_check_letter: "حرف إنجليزي",
    pw_check_digit: "رقم",
    pw_check_symbol: "رمز خاص (@ # $ ! …)",
    pw_match_ok: "كلمتا المرور متطابقتان ✓",
    pw_match_fail: "كلمتا المرور غير متطابقتين",
    processing: "جاري المعالجة...",
    verifying_email: "جاري تأكيد البريد الإلكتروني",
    verify_success_title: "تم تأكيد بريدك ✓",
    verify_success_msg: "تم تفعيل حسابك بنجاح.",
    verify_failed: "فشل التحقق",
    verify_failed_title: "تعذّر التحقق",
    verify_missing_token: "رمز التحقق مفقود",
    back_to_login: "الرجوع لصفحة الدخول",
    footer_tagline: "Barn's Tracker",

    // Nav
    nav_dashboard: "لوحة التحكم",
    menu: "القائمة",
    nav_admin_certs: "شهادات الإدارة",
    admin_certs_subtitle: "تتبع شهادات مدراء المناطق والمشرفين",
    view_all_employees: "عرض جميع الموظفين",
    position_supervisor: "مشرف",
    position_area_manager: "مدير منطقة",
    my_health_cert: "شهادتي الصحية",
    my_health_cert_none: "لم تتم إضافة شهادة صحية باسمك بعد. اطلب من مدير المنطقة إضافتها تحت فرع الإدارة.",
    add_my_cert_button: "أضف شهادتي الآن",
    edit_my_cert_button: "تعديل شهادتي",
    my_cert_modal_title: "أضف/عدّل شهادتك الصحية",
    my_cert_modal_help: "أدخل بيانات شهادتك الصحية — ستظهر تلقائياً في ملفك الشخصي ولدى مدير المنطقة والسوبر ادمن دون الحاجة لموافقة إضافية. الاسم:",
    cert_expiry_required: "تاريخ انتهاء الشهادة الصحية (هجري) مطلوب — الصيغة: YYYY-MM-DD",
    hijri_format_hint: "الصيغة: 1447-06-15 (سنة-شهر-يوم)",
    cert_candidates_title: "شهادات مضافة في فرع الإدارة قد تخصك — اربطها بحسابك",
    cert_candidates_help: "اضغط \"هذه شهادتي\" على السجل الذي يخصك — سيتم ربطه بحسابك وسيظهر في ملفك تلقائياً.",
    cert_claim_button: "هذه شهادتي",
    days: "يوم",
    expiring_soon: "قاربت على الانتهاء",
    valid: "سارية",
    expired: "منتهية",
    missing_cert: "غير مسجلة",
    nav_positions: "المناصب",
    positions_subtitle: "إدارة قائمة المناصب المتاحة وتحديد أين تظهر",
    add_position: "إضافة منصب",
    edit_position: "تعديل منصب",
    position_name: "اسم المنصب",
    position_name_hint: "اكتب الاسم بالإنجليزية (مثال: Store Manager)",
    position_scope: "أين يظهر هذا المنصب؟",
    position_scope_hint: "فروع = يظهر عند إضافة موظف في فرع عادي · الإدارة = يظهر لموظفي فرع الإدارة · الكل = يظهر في كل الحالات",
    position_name_required: "اسم المنصب مطلوب",
    no_positions: "لا توجد مناصب حالياً",
    default: "افتراضي",
    cannot_delete_default: "لا يمكن حذف منصب افتراضي",
    delete_position_confirm: "حذف المنصب \"{name}\"؟",
    duplicate_found_title: "تنبيه: قد يوجد سجل مطابق لهذه البيانات",
    duplicate_blocked_title: "لا يمكن حفظ السجل — بيانات مكررة",
    duplicate_blocked_desc: "الرقم الوظيفي أو رقم الإقامة أو الجوال مسجّل بالفعل. تحقق من مكان السجل الأصلي:",
    dup_matched_on: "تطابق في",
    dup_field_iqama_number: "رقم الإقامة",
    dup_field_employee_id: "الرقم الوظيفي",
    dup_field_phone: "رقم الجوال",
    duplicate_branch_code_error: "كود الفرع \"{code}\" مستخدم مسبقاً تحت مدير المنطقة: {area_manager_name}",
    duplicate_branch_name_error: "اسم الفرع \"{name}\" مستخدم مسبقاً تحت مدير المنطقة: {area_manager_name}",
    duplicate_admin_name_error: "اسم المشرف \"{name}\" مستخدم مسبقاً في منطقتك",
    duplicate_admin_email_error: "البريد الإلكتروني مسجّل لمشرف آخر: {name} · {area_manager_name}",
    duplicate_admin_phone_error: "رقم الجوال مسجّل لمشرف آخر: {name} · {area_manager_name}",
    close: "إغلاق",
    profile: "الملف الشخصي",
    nav_employees: "الموظفون",
    nav_branches: "الفروع",
    nav_admins: "المشرفون",
    nav_area_managers: "مدراء المناطق",
    logout: "خروج",
    shortcut_balady: "تحقق من كرت البلدية",
    shortcut_location: "موقعنا على الخريطة",
    role_super_admin: "مالك",
    role_area_manager: "مدير منطقة",
    role_supervisor: "مشرف",
    // Profile
    nav_profile: "الملف الشخصي",
    profile_subtitle: "إدارة بياناتك الشخصية وكلمة المرور",
    save_profile: "حفظ التعديلات",
    profile_saved: "تم حفظ التعديلات بنجاح",
    save_failed: "تعذّر الحفظ",
    email_change_hint: "عند تغيير البريد سيُطلب منك تأكيده من جديد",
    change_password: "تغيير كلمة المرور",
    change_password_subtitle: "اختر كلمة مرور قوية تحتوي حروف وأرقام ورموز",
    current_password: "كلمة المرور الحالية",
    new_password: "كلمة المرور الجديدة",
    password_changed: "تم تغيير كلمة المرور بنجاح",
    email_unverified_title: "بريدك الإلكتروني غير مؤكّد",
    email_unverified_msg: "أرسلنا رسالة تأكيد إلى {email}. تحقق من بريدك أو أعد إرسال الرسالة.",
    resend_verification: "إعادة إرسال التأكيد",
    verification_resent: "تم إرسال الرسالة. تحقق من بريدك",
    // Supervisor login (admin row)
    supervisor_login_create: "إنشاء حساب دخول للمشرف",
    supervisor_login_edit: "تعديل حساب دخول المشرف",
    supervisor_login_hint: "إنشاء اسم مستخدم وكلمة مرور للمشرف ليدخل ويشاهد موظفيه فقط.",
    create_login: "إنشاء حساب دخول",
    revoke_login: "إلغاء الدخول",
    confirm_revoke_supervisor_login: "هل تريد إلغاء حساب دخول هذا المشرف؟",
    supervisor_login_save_failed: "تعذّر حفظ بيانات الدخول",
    move_branch_area_title: "نقل الفرع لمنطقة أخرى",
    move_branch_area_pick_am: "اختر مدير المنطقة الجديد",
    move_branch_area_no_sup: "بدون مشرف مؤقتاً (يُعين لاحقاً)",
    move_branch_area_btn: "نقل الفرع وجميع موظفيه",
    move_branch_area_confirm: "سيُنقل فرع «{branch}» وجميع موظفيه إلى منطقة {am}، ويُفك ربط المشرف الحالي. متابعة؟",
    move_branch_area_success: "✅ نُقل الفرع و{count} موظفاً للمنطقة الجديدة — أُشعر المديران",
    move_branch_area_confirm_btn: "تأكيد النقل الآن",
    move_branch_area_cancel_btn: "تراجع",
    move_branch_area_pending_save_warn: "⚠️ اخترت نقل الفرع لمنطقة أخرى — زر «حفظ» لا ينفذ النقل. اضغط زر «نقل الفرع وجميع موظفيه» بالأسفل، أو ألغِ اختيار المدير أولاً.",
    dayoff_unconfirm_title: "فك اعتماد دي أوف — {name}",
    dayoff_unconfirm_warn: "سيُفك الاعتماد فوراً ويُسجل ذلك في سجل التدقيق مع إشعار المعنيين. التغييرات بعد الفك لن تُرصد كتعديلات على خطة معتمدة.",
    dayoff_unconfirm_request_warn: "لا يمكنك فك الاعتماد مباشرة — سيُرسل طلب لمدير المنطقة للموافقة عليه مع السبب.",
    dayoff_unconfirm_reason_label: "سبب فك الاعتماد",
    dayoff_unconfirm_reason_ph: "اكتب سبباً واضحاً…",
    dayoff_unconfirm_reason_required: "السبب إلزامي لفك الاعتماد",
    dayoff_unconfirm_request_btn: "إرسال طلب فك الاعتماد",
    dayoff_unconfirm_direct_btn: "فك الاعتماد الآن",
    dayoff_unconfirm_request_sent: "✅ أُرسل طلب فك الاعتماد لمدير المنطقة",
    dayoff_unconfirm_pending_tip: "يوجد طلب فك اعتماد قيد الموافقة لهذا الموظف",
    dayoff_unconfirm_requests_title: "طلبات فك الاعتماد المعلقة",
    dayoff_unconfirm_req_by: "الطالب",
    dayoff_approve_unconfirm: "موافقة وفك الاعتماد",
    dayoff_reject_unconfirm: "رفض",
    dayoff_unconfirm_approved_msg: "تمت الموافقة وفُك الاعتماد",
    dayoff_unconfirm_rejected_msg: "رُفض الطلب — الاعتماد باقٍ",
    role_branch_manager: "مدير فرع",
    branch_type_label: "نوع الفرع",
    branch_type_premium_hint: "فرع Premium — يمكن تعيين مدير فرع له من صفحة المشرفين ← تبويب مدراء الفروع",
    bm_tab_title: "مدراء الفروع (Premium)",
    bm_subtitle: "مدير الفرع يدير فرع Premium واحداً وموظفيه فقط — بالصلاحيات التي تحددها له",
    bm_add: "إضافة مدير فرع",
    bm_edit_title: "تعديل مدير الفرع",
    bm_name: "الاسم",
    bm_branch: "الفرع",
    bm_branch_hint: "تظهر فروع Premium فقط — غيّر نوع الفرع من صفحة الفروع إن لم يظهر",
    bm_area_manager: "مدير المنطقة",
    bm_modules: "الأقسام المفعلة",
    bm_empty: "لا يوجد مدراء فروع بعد — أضف أول مدير لفرع Premium",
    bm_delete_confirm: "حذف حساب مدير الفرع {name}؟ لن يستطيع الدخول بعدها.",
    bm_perms_title: "الصلاحيات",
    bm_perms_hint: "فعّل القسم أولاً ثم حدد الصلاحيات التفصيلية — القسم المقفل لا يظهر لمدير الفرع إطلاقاً",
    bm_mod_employees: "كروت البلدية",
    bm_mod_licenses: "رخص الفروع",
    bm_mod_dayoff: "Day Off",
    bm_mod_empmgmt: "إدارة الموظفين",
    bm_perm_emp_view: "عرض الموظفين",
    bm_perm_emp_add: "إضافة موظف",
    bm_perm_emp_edit: "تعديل موظف",
    bm_perm_emp_certificates: "الشهادات",
    bm_perm_emp_attachments: "المرفقات",
    bm_perm_emp_export: "تصدير",
    bm_perm_lic_view: "عرض الرخص",
    bm_perm_lic_edit: "تعديل الرخص",
    bm_perm_lic_attachments: "مرفقات الرخص",
    bm_perm_dayoff_view: "عرض",
    bm_perm_dayoff_edit: "تعديل",
    bm_perm_dayoff_confirm: "اعتماد",
    bm_perm_em_view: "عرض الموظفين",
    bm_perm_em_add: "إضافة موظف",
    bm_perm_em_edit: "تعديل",
    bm_perm_em_transfer: "طلب نقل",
    bm_perm_em_vacation: "إجازة/عودة",
    bm_perm_em_documents: "المستندات",
    bm_perm_em_reports: "التقارير",
    bm_perm_notif_view: "عرض التنبيهات",
    email_optional: "البريد الإلكتروني (اختياري)",
    status: "الحالة",
    ss_reset_btn: "إعادة تعيين كلمة المرور",
    ss_ch_requester_telegram: "تيليجرام المُصدر",
    ss_ch_super_admin_telegram: "تيليجرام السوبر أدمن",
    bm_no_login: "إنشاء حساب دخول",
    bm_creds_title: "إنشاء حساب دخول لمدير الفرع",
    bm_creds_saved: "✅ أُنشئ حساب الدخول — يستطيع مدير الفرع الدخول الآن",
    bm_pending_title: "فروع Premium بدون مدير فرع",
    bm_pending_hint: "اختر موظفاً من جدول موظفي الفرع لتعيينه مدير فرع (سيُفك ربط المشرف تلقائياً)، أو اضغط تجاهل",
    bm_pending_pick: "— اختر موظفاً من الفرع —",
    bm_pending_assign: "تعيين مدير فرع",
    bm_pending_ignore: "تجاهل",
    bm_pending_has_sup: "حالياً تحت مشرف — سيُفك عند التعيين",
    bm_assigned_ok: "✅ عُين مدير الفرع وفُك ربط المشرف — أنشئ له حساب دخول وحدد صلاحياته",
    move_branch_area_hint: "ينقل الفرع وكل موظفيه للمنطقة الجديدة ويفك ربط المشرف القديم — يُسجل في التدقيق ويُشعر المديرين.",
    supervisor_login_created_ok: "✅ تم إنشاء حساب الدخول للمشرف بنجاح",
    supervisor_login_updated_ok: "✅ تم تحديث بيانات الدخول بنجاح",
    optional: "اختياري",
    password_update_placeholder: "اتركها فارغة لإبقاء كلمة المرور الحالية",
    // Impersonate
    login_as: "دخول باسمه",
    login_as_manager: "تسجيل دخول كهذا المدير لمعاينة بياناته",
    confirm_impersonate: "سيتم تسجيل دخولك كـ \"{name}\". لتعود لحسابك، اضغط خروج ثم سجّل دخولك مرة أخرى.",
    // Module chooser (post-login)
    chooser_welcome: "أهلاً بك 👋 اختر المتتبع",
    chooser_hint: "يمكنك التبديل بين المتتبعَين لاحقاً من القائمة الجانبية",
    chooser_click_enter: "اضغط للدخول",
    chooser_module_employees_title: "شهادات الموظفين الصحية",
    chooser_module_employees_subtitle: "الشهادة الصحية · التثقيف · كرد البلدية",
    chooser_module_licenses_title: "رخص الفروع",
    chooser_module_licenses_subtitle: "رخصة الفرع · رخصة الدفاع المدني",
    chooser_module_dayoff_subtitle: "تتبع أيام الإجازة الأسبوعية للموظفين",
    chooser_module_empmgmt_title: "إدارة الموظفين",
    chooser_module_empmgmt_subtitle: "النقل · الترقيات · الإجازات · ملف الموظف",
    em_module_name: "إدارة الموظفين",
    em_dash_intro: "النظام الرئيسي لإدارة الموظفين وحركتهم الوظيفية — كل عملية تمر بالاعتماد قبل تطبيقها",
    em_phase_note: "المرحلة الأولى: هيكل مبدئي للمراجعة — لا توجد وظائف مفعّلة بعد",
    em_placeholder_badge: "قيد التخطيط",
    em_placeholder_text: "هذه الصفحة هيكل مبدئي فقط. سيتم عرض مخطط الواجهة وسير العمل عليك للاعتماد قبل بدء التنفيذ.",
    em_nav_dashboard: "لوحة التحكم",
    em_nav_employees: "الموظفون",
    em_nav_transfers: "التنقلات",
    em_nav_promotions: "الترقيات",
    em_nav_vacations: "الإجازات",
    em_nav_files: "ملفات الموظفين",
    em_nav_approvals: "بانتظار الاعتماد",
    em_nav_reports: "التقارير",
    em_nav_audit: "سجل التدقيق",
    em_nav_settings: "الإعدادات",
    nav_system_settings: "إعدادات النظام",
    ss_title: "إعدادات النظام",
    ss_intro: "قسم مستقل للسوبر أدمن فقط — التحكم العام في النظام",
    ss_permissions: "إدارة الصلاحيات",
    ss_dynamic_fields: "الحقول الديناميكية",
    ss_system: "إعدادات النظام",
    ss_modules: "إعدادات الوحدات",
    ss_notifications: "إعدادات التنبيهات",
    ss_general: "إعدادات عامة",
    ss_fields_hint: "مسميات نعم/لا تظهر في تفاصيل كل موظف داخل إدارة الموظفين (مثال: يونيفورم، كاب…)",
    ss_digest_email: "التقرير اليومي بالبريد",
    ss_digest_telegram: "التقرير اليومي تيليجرام",
    ss_default_warning: "أيام التحذير الافتراضية",
    ss_days: "يوم",
    ss_notif_hint: "إيقاف التقرير يمنع الإرسال اليومي المجدول (8 صباحاً) للجميع",
    ss_modules_hint: "إخفاء وحدة يزيلها من شاشة اختيار الوحدات لكل المستخدمين",
    ss_mod_licenses: "رخص الفروع",
    ss_mod_dayoff: "Day off MenaMe",
    ss_info_area_managers: "مدراء المناطق",
    ss_info_supervisors_users: "حسابات المشرفين",
    ss_info_supervisors: "المشرفون",
    ss_info_branches: "الفروع",
    ss_info_employees: "الموظفون",
    ss_info_em_requests: "طلبات إدارة الموظفين",
    ss_info_em_fields: "الحقول المخصصة",
    ss_info_audit_logs: "سجلات التدقيق",
    ss_perm_capability: "الصلاحية",
    perm_view_all: "رؤية كل المناطق",
    perm_manage_ams: "إدارة مدراء المناطق",
    perm_manage_sups: "إدارة المشرفين",
    perm_manage_branches: "إدارة الفروع",
    perm_add_employees: "إضافة/تعديل الموظفين",
    perm_delete_employees: "حذف الموظفين",
    perm_licenses_edit: "تعديل رخص الفروع",
    perm_dayoff: "جدول الدي أوف",
    perm_em_approve: "اعتماد طلبات إدارة الموظفين",
    perm_system_settings: "إعدادات النظام",
    ss_perms_hint: "عرض توضيحي للصلاحيات الحالية — التحكم الكامل بالصلاحيات مرحلة قادمة",
    ss_perms_edit_hint: "اضغط على العلامة لتفعيل أو إلغاء الصلاحية — يُطبق فوراً على الجميع (السوبر أدمن صلاحياته كاملة دائماً)",
    perm_em_requests: "طلبات النقل/الترقية/الإجازة",
    em_settings_super_only: "إعدادات الوحدة (الحقول المخصصة) يديرها السوبر أدمن من إعدادات النظام",
    em_load_error: "تعذر تحميل بيانات الموظفين",
    em_search_ph: "بحث: الاسم / الرقم / الإقامة…",
    em_all_am: "كل مدراء المناطق",
    em_all_mum: "كل المشرفين",
    em_all_branches: "كل الفروع",
    em_all_companies: "كل الشركات",
    em_all_nats: "كل الجنسيات",
    em_all_positions: "كل المناصب",
    em_col_branch: "BRANCH NAME",
    em_col_name: "TEAM MEMBER NAME",
    em_col_position: "POSITION",
    em_no_matches: "لا توجد نتائج مطابقة",
    em_download_btn: "تنزيل Staff Update",
    em_download_done: "تم تنزيل الملف",
    em_download_error: "فشل تنزيل الملف",
    em_import_btn: "استيراد Staff Update",
    em_import_done: "تم الاستيراد: تطابق {matched} · تحديث {updated} موظف · {branches} فرع",
    em_import_error: "فشل الاستيراد",
    em_import_report_title: "تقرير الاستيراد",
    em_import_hint: "يتم تعبئة البيانات الناقصة فقط — النظام هو المصدر الأساسي ولا يتم استبدال أي بيانات موجودة أو إنشاء موظفين جدد",
    em_import_stat_matched: "تطابق",
    em_import_stat_filled: "حقول تمت تعبئتها",
    em_import_stat_updated: "موظف محدث",
    em_import_stat_branches: "فرع محدث",
    em_import_conflicts_title: "اختلافات لم يتم دمجها ({n})",
    em_import_conflicts_hint: "قيم مختلفة بين النظام والملف — لم يتم تغييرها، راجعها يدوياً",
    em_import_unmatched_title: "غير موجودين في النظام ({n})",
    em_import_unmatched_hint: "أرقام في الملف لا تطابق أي موظف ضمن نطاقك — لم يتم إنشاؤهم لتجنب التكرار",
    em_import_no_issues: "لا توجد اختلافات أو ملاحظات ✓",
    em_conf_emp: "الموظف / الفرع",
    em_conf_field: "الحقل",
    em_conf_current: "في النظام",
    em_conf_file: "في الملف",
    em_build_title: "بناء قاعدة بيانات مدير منطقة",
    em_build_hint: "يوجد موظفون في الملف غير موجودين في النظام. اختر اسم مدير المنطقة (عمود AM في الملف) ليتم إنشاء فروعه ومشرفيه وموظفيه تلقائياً — بدون شهادات بلدية (تُضاف لاحقاً من كروت البلدية)",
    em_build_select_am: "اسم مدير المنطقة في الملف (AM)",
    em_build_target_am: "حساب مدير المنطقة المستهدف",
    em_build_btn: "بناء قاعدة البيانات",
    em_build_confirm: "سيتم إنشاء الفروع والمشرفين والموظفين لصفوف {am} من الملف. متابعة؟",
    em_build_rows: "صف",
    em_build_done_title: "تم بناء قاعدة البيانات — {am}",
    em_build_stat_employees: "موظف منشأ",
    em_build_stat_branches: "فرع منشأ",
    em_build_stat_supervisors: "مشرف منشأ",
    em_build_stat_skipped: "صف لمدراء آخرين (تم تجاهله)",
    em_build_foreign_title: "موجودون عند مدير منطقة آخر ({n})",
    em_build_foreign_hint: "لم يتم نقلهم أو تكرارهم — استخدم طلبات النقل إذا لزم",
    em_saved: "تم الحفظ",
    em_save_error: "فشل الحفظ",
    em_trial_note: "وضع تجريبي — كل الأقسام تعمل للمعاينة، وأي عملية تمر بالاعتماد قبل تطبيقها. أبلغنا بأي تعديل أو إلغاء",
    em_type_transfer: "نقل",
    em_type_promotion: "ترقية",
    em_type_vacation: "إجازة",
    em_type_vacation_return: "عودة من إجازة",
    em_type_sup_transfer: "نقل مشرف",
    em_req_sup_transfer_btn: "طلب نقل مشرف",
    em_pick_supervisor: "اختر المشرف",
    em_sup_transfer_hint: "نقل المشرف ينقل معه كل فروعه وموظفيه إلى مدير المنطقة الجديد، وينعكس تلقائياً على كروت البلدية والرخص والدي أوف",
    em_full_edit_btn: "تعديل كامل البيانات (الاسم/الفرع/المشرف…)",
    em_staff_fields_title: "بيانات Staff Update (إدارة الموظفين)",
    em_transfer_xlsx_btn: "تنزيل نموذج النقل (Excel)",
    em_xlsx_from: "من تاريخ",
    em_xlsx_to: "إلى تاريخ",
    em_files_hint: "اضغط على أي موظف لفتح ملفه الكامل: البيانات، الخط الزمني، سجل النشاط، والمستندات",
    em_former_badge: "موظف سابق",
    em_show_former: "الموظفون السابقون",
    em_timeline: "الخط الزمني",
    em_activity_log: "سجل النشاط",
    em_no_events: "لا توجد أحداث",
    em_by: "بواسطة",
    em_ev_hired: "تعيين",
    em_ev_branch_change: "تغيير فرع",
    em_ev_supervisor_change: "تغيير مشرف",
    em_ev_am_change: "تغيير مدير منطقة",
    em_ev_data_edit: "تعديل بيانات",
    em_ev_document_added: "إضافة مستند",
    em_ev_archived: "أرشفة",
    em_field_col: "الحقل",
    em_old_val: "قبل",
    em_new_val: "بعد",
    em_docs_title: "مستندات الموظف",
    em_doc_category: "التصنيف",
    em_doc_upload: "رفع مستند",
    em_doc_title_ph: "عنوان المستند",
    em_doc_expiry: "تاريخ الانتهاء (اختياري)",
    em_doc_expiry_short: "ينتهي",
    em_doc_note_ph: "ملاحظة (اختياري)",
    em_doc_uploaded: "تم رفع المستند ✅",
    em_doc_deleted: "تم حذف المستند",
    em_doc_delete_confirm: "حذف المستند؟",
    em_doc_pick_required: "اختر التصنيف والملف أولاً",
    em_doc_new_cat_ph: "تصنيف جديد…",
    em_doc_add_cat: "إضافة تصنيف",
    em_municipal_attachments: "مرفقات البلدية (للقراءة فقط)",
    em_no_docs: "لا توجد مستندات",
    em_approve_note_ph: "ملاحظة الاعتماد (اختياري)",
    em_approve_confirm: "تأكيد الاعتماد",
    em_approve_note_label: "ملاحظة الاعتماد",
    date: "التاريخ",
    download: "تنزيل",
    em_status_pending: "معلق",
    em_status_approved: "معتمد",
    em_status_rejected: "مرفوض",
    em_col_type: "النوع",
    em_col_emp: "الموظف",
    em_col_date: "التاريخ",
    em_col_status: "الحالة",
    em_from: "من",
    em_to: "إلى",
    em_requested_by: "مقدم الطلب",
    em_decided_by: "اعتمده",
    em_reject_reason: "سبب الرفض",
    em_reject_reason_ph: "اكتب سبب الرفض…",
    em_approve: "اعتماد",
    em_reject: "رفض",
    em_send_request: "إرسال الطلب",
    em_request_sent: "تم إرسال الطلب — بانتظار الاعتماد",
    em_transfer_applied: "تم تنفيذ النقل مباشرة ✅",
    em_custom_fields: "حقول إضافية",
    em_last_data: "آخر بيانات الموظف",
    em_field_level_critical: "حرجة",
    em_field_level_normal: "عادي",
    em_field_level_hint: "إذا كان الحقل حرجاً وقيمته 'لا' يظهر تنبيه حرج لمدير المنطقة حتى تتغير إلى 'نعم'",
    em_add_employee: "إضافة موظف",
    em_on_vacation_now: "الموظفون في إجازة حالياً",
    em_vacation_view_all: "عرض الكل",
    em_vacation_overdue: "متأخر عن العودة",
    em_end_vacation_btn: "إنهاء الإجازة وإعادته للفرع",
    em_end_vacation_confirm: "سيتم إنهاء إجازة {name} وإعادته إلى فرعه السابق وتسجيل العملية. متابعة؟",
    em_vacation_ended: "تم إنهاء الإجازة وإعادة الموظف إلى فرعه",
    em_no_vacation_now: "لا يوجد موظفون في إجازة حالياً",
    em_archive_employee: "أرشفة الموظف",
    em_archive_confirm: "سيتم حذف الموظف من القوائم النشطة ونقله إلى الموظفين السابقين مع الاحتفاظ بكل سجلاته ومستنداته. متابعة؟",
    em_archived_ok: "تم نقل الموظف إلى الموظفين السابقين",
    em_manage_fields: "إدارة المسميات",
    em_no_fields: "لا توجد حقول — يضيفها السوبر أدمن من «إدارة المسميات»",
    em_field_name_ph: "اسم الحقل (مثال: يونيفورم)…",
    em_add_field: "إضافة",
    em_request_error: "تعذر تنفيذ العملية",
    em_approved_toast: "تم الاعتماد والتطبيق ✅",
    em_rejected_toast: "تم رفض الطلب",
    em_tab_pending: "المعلقة",
    em_tab_history: "السجل",
    em_no_requests: "لا توجد طلبات",
    em_pick_employee: "ابحث عن الموظف بالاسم أو الرقم…",
    em_pick_dest_am: "مدير المنطقة (الوجهة)",
    em_pick_dest_mum: "المشرف (الوجهة)",
    em_pick_dest_branch: "الفرع (الوجهة)",
    em_new_position: "المسمى الوظيفي الجديد",
    em_start_date: "تاريخ بداية الإجازة",
    em_return_date: "تاريخ العودة المتوقع",
    em_actual_return: "تاريخ العودة الفعلي",
    em_note_label: "ملاحظة",
    em_req_transfer_btn: "طلب نقل",
    em_req_promotion_btn: "طلب ترقية",
    em_req_vacation_btn: "طلب إجازة",
    em_req_return_btn: "تسجيل عودة",
    em_approvals_flow_hint: "كل الطلبات تدخل «بانتظار الاعتماد» ولا تُطبق إلا بعد اعتماد مدير المنطقة",
    em_approvals_only_am: "الاعتماد والرفض من صلاحية مدير المنطقة — يمكنك متابعة حالة طلباتك هنا",
    em_archive_title: "التقارير — أرشيف الحركات",
    em_all_types: "كل الأنواع",
    em_archive_download: "تنزيل الأرشيف Excel",
    em_stat_employees: "الموظفون",
    em_stat_pending: "بانتظار الاعتماد",
    em_stat_approved_today: "اعتُمد اليوم",
    em_stat_rejected: "مرفوضة",
    em_stat_on_vacation: "في إجازة",
    em_on_vacation_badge: "في إجازة",
    em_view_profile: "عرض ملف الموظف",
    em_profile_pending: "طلبات معلقة",
    em_profile_history: "سجل الحركات",
    em_profile_attachments: "المرفقات",
    em_profile_cert: "الشهادة الصحية (انتهاء)",
    nav_dayoff: "تتبع الدي أوف",
    dayoff_subtitle: "تتبع أيام الإجازة الأسبوعية (من 16 إلى 15)",
    dayoff_prev: "الدورة السابقة",
    dayoff_next: "الدورة التالية",
    dayoff_current: "الدورة الحالية",
    dayoff_search: "بحث عن موظف…",
    dayoff_all_branches: "كل الفروع",
    dayoff_employees_word: "موظف",
    dayoff_employee: "الموظف",
    dayoff_total: "المجموع",
    dayoff_hint: "اضغط على خانة اليوم لتحديد الدي أوف، واضغط مرة أخرى لإلغائه",
    dayoff_no_employees: "لا يوجد موظفون",
    dayoff_load_error: "تعذر تحميل البيانات",
    dayoff_save_error: "تعذر حفظ التعديل",
    dayoff_all_supervisors: "كل المشرفين",
    dayoff_emp_no: "الرقم الوظيفي",
    dayoff_download: "تنزيل إكسل",
    dayoff_export_error: "تعذر تنزيل الملف",
    dayoff_pick_month: "اختر الشهر",
    dayoff_picker_hint: "اختيار الشهر يعرض الدورة من 16 فيه إلى 15 من الشهر التالي",
    dayoff_shift: "الشفت",
    dayoff_shift_edit: "تعديل الشفت",
    dayoff_shift_title: "تحديد شفت الموظف",
    dayoff_shift_from: "يسري من تاريخ",
    dayoff_shift_from_hint: "لو تغيّر الشفت وسط الدورة، حدد اليوم اللي بدأ منه الشفت الجديد",
    dayoff_shift_whole_cycle: "تطبيق على كامل الدورة (يلغي أي تغيير شفت سابق)",
    dayoff_shift_save: "حفظ الشفت",
    dayoff_shift_saved: "تم حفظ الشفت",
    dayoff_shift_unset: "حدد الشفت",
    dayoff_set_shift_first: "حدد شفت الموظف أولاً قبل تحديد أيام الدي أوف",
    dayoff_shift_pick_required: "اختر AM أو PM أولاً",
    tg_title: "تنبيهات تيليجرام",
    tg_subtitle: "اربط حسابك ليصلك إشعار فوري بالتنبيهات (الشهادات، الرخص، أيام الأوف)",
    tg_linked: "مرتبط",
    tg_link_btn: "ربط تيليجرام",
    tg_unlink: "إلغاء الربط",
    tg_verify: "تحقق من الربط",
    tg_open_bot: "فتح البوت",
    tg_step1: "اضغط «فتح البوت» — بيفتح تيليجرام على بوت Barns Tracker",
    tg_step2: "اضغط زر Start (ابدأ) داخل البوت",
    tg_step3: "ارجع هنا واضغط «تحقق من الربط»",
    tg_linked_success: "تم الربط بنجاح! وصلتك رسالة ترحيب في تيليجرام ✅",
    tg_lang_label: "لغة رسائل التنبيهات",
    transfers_title: "طلبات النقل",
    transfers_incoming: "طلبات واردة (تحتاج اعتمادك)",
    transfers_outgoing: "طلباتي المرسلة",
    transfers_none: "لا توجد طلبات",
    transfer_approve: "اعتماد",
    transfer_reject: "رفض",
    transfer_from: "من منطقة",
    transfer_to: "إلى منطقة",
    transfer_by: "مقدم الطلب",
    transfer_status_approved: "معتمد",
    transfer_status_rejected: "مرفوض",
    transfer_status_pending: "بانتظار الاعتماد",
    transfer_request_sent: "تم إرسال طلب النقل — بانتظار اعتماد مدير المنطقة المستلم",
    transfer_approved_toast: "تم اعتماد النقل ونقل الموظف بنجاح",
    transfer_rejected_toast: "تم رفض طلب النقل",
    transfer_needs_approval_hint: "النقل لمنطقة أخرى يتطلب اعتماد مدير المنطقة المستلم — سيصله إشعار بالطلب",
    dayoff_export_new_emps: "الموظفون الجدد — الملفين معاً",
    dayoff_export_new_emps_hint: "من انضاف خلال الدورة الحالية فقط",
    trial_badge: "تجريبي",
    activity_last_seen: "آخر ظهور",
    activity_title: "نشاط الدخول",
    activity_details: "تفاصيل الدخول والجلسات",
    activity_online_now: "متصل الآن 🟢",
    activity_mins_ago: "قبل {n} دقيقة",
    activity_hours_ago: "قبل {n} ساعة",
    activity_week_engagement: "الالتزام الأسبوعي",
    activity_days_count: "{n} أيام دخول",
    activity_month_engagement: "الالتزام الشهري (آخر ٣٠ يوم)",
    activity_download: "تنزيل التقرير",
    em_supervisors_card_hint: "بيانات المشرفين ونشاط الدخول",
    em_days_count: "{n} يوم",
    em_days_selected: "مدة الإجازة: {n} يوم",
    em_days_invalid: "⚠️ تاريخ العودة يجب أن يكون بعد تاريخ البداية",
    em_vac_duration: "المدة: {n} يوم",
    em_vac_remaining: "متبقي {n} يوم",
    ntype_all: "جميع أنواع التنبيهات",
    ntype_cert_missing_health: "لا توجد شهادة صحية",
    ntype_cert_expired_health: "الشهادة الصحية منتهية",
    ntype_cert_expiring_health: "الشهادة الصحية قاربت على الانتهاء",
    ntype_cert_missing_training: "لا يوجد تثقيف",
    ntype_cert_expired_training: "التثقيف منتهي",
    ntype_cert_expiring_training: "التثقيف قارب على الانتهاء",
    ntype_no_municipality_card: "لا توجد بطاقة بلدية",
    ntype_missing_data: "بيانات ناقصة",
    ntype_transfer_request: "طلب نقل موظف",
    ntype_transfer_result: "نتيجة طلب نقل",
    ntype_license_expired_all: "رخصة منتهية (كل الأنواع)",
    ntype_license_expiring_all: "رخصة قاربت على الانتهاء (كل الأنواع)",
    ntype_license_business: "رخصة الفرع",
    ntype_license_civil_defense: "رخصة الدفاع المدني",
    ntype_dayoff_change: "تغيير بعد الاعتماد",
    ntype_dayoff_confirm_note: "اعتماد مع ملاحظة (أسبوع ناقص)",
    ntype_dayoff_reminder: "تذكير اعتماد",
    ntype_dayoff_new_employee: "موظف جديد",
    ntype_em_request_pending: "طلب بانتظار الاعتماد",
    ntype_em_request_result: "نتيجة طلب (اعتماد/رفض)",
    ntype_critical_field: "حقل حرج",
    ntype_vacation_return_soon: "قرب العودة من الإجازة",
    ntype_vacation_overdue: "تأخر عن العودة من الإجازة",
    em_ov_total_employees: "إجمالي الموظفين",
    em_ov_branches: "عدد الفروع",
    em_ov_supervisors: "عدد المشرفين",
    em_ov_area_managers: "مدراء المناطق",
    em_restore: "استعادة",
    em_restore_left: "متبقي {n} يوم لإمكانية الاستعادة",
    em_restore_expired: "انتهت مهلة الاستعادة",
    em_restore_confirm: "استعادة الموظف {name} وإرجاعه للقائمة النشطة؟",
    em_restored_ok: "✅ تمت استعادة الموظف بنجاح",
    ss_account_lookup: "البحث عن الحسابات",
    ss_lookup_placeholder: "ابحث بالبريد أو اسم المستخدم أو الاسم...",
    ss_lookup_no_results: "لا توجد حسابات مطابقة",
    ss_orphan_account: "سجل المشرف محذوف",
    ss_inactive: "معطّل",
    ss_gen_reset_link: "رابط إعادة تعيين",
    ss_reset_link_copied: "✅ تم إنشاء الرابط ونسخه — صالح لمدة ساعة",
    ss_reset_link_prompt: "انسخ الرابط وأرسله للمستخدم:",
    ss_delete_login: "حذف الحساب",
    ss_delete_login_confirm: "حذف حساب الدخول ({name})؟ سيتحرر البريد واسم المستخدم لإعادة الاستخدام.",
    ss_login_deleted: "✅ تم حذف حساب الدخول",
    ss_linked_supervisor: "المشرف المرتبط",
    ss_linked_am: "مدير المنطقة",
    ss_acc_click_hint: "اضغط على اسم الحساب لتعديل بياناته وارتباطاته",
    ss_edit_account: "تعديل الحساب",
    ss_acc_fullname: "الاسم الكامل",
    ss_acc_username: "اسم المستخدم",
    ss_acc_email: "البريد الإلكتروني",
    ss_acc_active: "الحساب مفعّل",
    ss_acc_linked_admin: "سجل المشرف المرتبط",
    ss_acc_linked_am: "مدير المنطقة المرتبط",
    ss_acc_saved: "✅ تم حفظ بيانات الحساب",
    em_archive_tab_movements: "أرشيف الحركات",
    em_archive_tab_former: "الموظفون السابقون",
    em_nav_archive: "أرشيف الموظفين",
    em_emp_archive_title: "أرشيف الموظفين",
    em_former_empty: "لا يوجد موظفون سابقون",
    em_former_hint: "يمكن استعادة الموظف خلال المدة المحددة في إعدادات النظام، وبعد انتهائها تصبح الاستعادة غير متاحة — السجل التاريخي يبقى محفوظاً دائماً",
    em_archived_on: "تاريخ الأرشفة",
    em_archived_by: "أرشفه",
    em_archived_reason: "سبب الأرشفة",
    em_archive_reason_prompt: "سبب الأرشفة (اختياري):",
    em_last_branch: "آخر فرع",
    em_last_sup: "آخر مشرف",
    em_filter_label: "فلتر",
    em_filter_approved_today: "اعتمد اليوم",
    em_filter_rejected: "مرفوضة",
    em_filter_all: "الكل",
    ss_restore_window: "مدة استعادة الموظف المؤرشف",
    ss_otp_expiry: "صلاحية رمز الدخول المؤقت (OTP)",
    ss_minutes: "دقيقة",
    ss_reset_otp: "إعادة تعيين كلمة المرور",
    ss_otp_confirm: "إرسال رمز دخول مؤقت (OTP) لحساب {name}؟ سيصل الرمز إلى بريد/تليجرام المستخدم نفسه.",
    ss_otp_sent: "✅ تم إرسال الرمز المؤقت عبر: {channels}",
    ss_ch_email: "البريد الإلكتروني",
    ss_ch_telegram: "تليجرام",
    ss_ch_admin_email: "بريد السوبر أدمن",
    ss_otp_tg_contact: "رابط تيليجرام للتواصل مع المستخدم (انسخه لإرسال الرمز له مباشرة):",
    acct_mgmt_title: "إدارة الحساب",
    acct_no_login: "لا يوجد حساب دخول لهذا المشرف — أنشئ حساب دخول أولاً من زر المفتاح في القائمة",
    ss_convert_title: "تحويل إلى مشرف",
    ss_convert_hint: "إذا سُجّل هذا الحساب بالخطأ كمدير منطقة، حوّله لحساب مشرف مع الحفاظ الكامل على اسم المستخدم والبريد وكلمة المرور — بدون حذف أي شيء",
    ss_convert_existing: "ربط بسجل مشرف موجود",
    ss_convert_new_under: "أو إنشاء سجل مشرف جديد تحت مدير المنطقة",
    ss_convert_btn: "تحويل إلى مشرف",
    ss_convert_confirm: "تحويل حساب {name} إلى مشرف؟ سيحتفظ بنفس بيانات الدخول ويعاد توجيهه كمشرف عند دخوله القادم.",
    ss_convert_done: "✅ تم التحويل إلى مشرف تحت إدارة {am} — نفس اسم المستخدم وكلمة المرور",
    ss_acc_phone: "رقم الجوال",
    ss_acc_telegram: "تليجرام",
    ss_acc_tg_linked: "مرتبط ✓",
    ss_acc_tg_not_linked: "غير مرتبط",
    ss_acc_branches: "الفروع المرتبطة",
    ss_acc_no_branches: "لا توجد فروع مرتبطة",
    ss_acc_otp_pending: "يوجد رمز OTP نشط",
    fcp_title: "إنشاء كلمة مرور جديدة",
    fcp_subtitle: "دخلت برمز مؤقت — يجب تعيين كلمة مرور جديدة للمتابعة",
    fcp_new_password: "كلمة المرور الجديدة",
    fcp_confirm_password: "تأكيد كلمة المرور الجديدة",
    fcp_submit: "حفظ ومتابعة",
    fcp_success: "✅ تم تغيير كلمة المرور بنجاح",
    honor_board_title: "لوحة الشرف — الأعلى التزاماً هذا الشهر",
    honor_month_pct: "التزام {n}%",
    honor_tier_gold: "ذهبي",
    honor_tier_silver: "فضي",
    honor_tier_bronze: "برونزي",
    honor_score: "الدرجة: {n}%",
    honor_breakdown: "دخول {login}% · تفاعل {interact}%",
    honor_my_rank: "ترتيبك: #{rank} من {total} 💪",
    back_to_dashboard: "رجوع للوحة التحكم",
    back_to_sections: "الرجوع لاختيار الأقسام",
    sections_label: "الأقسام",
    activity_sessions: "آخر الجلسات (وقت الدخول · مدة الجلسة)",
    dayoff_cancel: "إلغاء",
    dayoff_changes_download: "ملف التغييرات",
    dayoff_changed_from: "تم تغيير الدي أوف — كان يوم {from}",
    dayoff_change_marked: "تم تسجيل التغيير: من {from} إلى {to}",
    dayoff_export_done: "تم التنزيل بنجاح",
    dayoff_export_file1: "الملف الأول",
    dayoff_export_file2: "الملف الثاني",
    dayoff_export_both: "تنزيل الملفين معًا",
    dayoff_export_changes_only: "التغييرات فقط",
    dayoff_export_changes_only_hint: "ملف بصيغة الروستر يحتوي الأيام المتغيرة فقط (الجديد ثم القديم)",
    dayoff_month_end: "نهاية الشهر",
    dayoff_confirm_tip: "اعتماد أيام الدي أوف لهذا الموظف — أي تغيير بعده يظهر بعلامة حمراء",
    dayoff_confirmed_tip: "معتمد — اضغط لإلغاء الاعتماد",
    dayoff_confirmed_msg: "تم اعتماد أيام الدي أوف",
    dayoff_unconfirmed_msg: "تم إلغاء الاعتماد",
    dayoff_audit: "سجل التدقيق",
    dayoff_audit_confirmed: "معتمد",
    dayoff_audit_unconfirmed: "بدون اعتماد",
    dayoff_audit_unconfirmed_title: "موظفون لم يعتمد المشرف أيامهم",
    dayoff_audit_all_confirmed: "جميع الموظفين معتمدون لهذه الدورة",
    dayoff_audit_changes_title: "التغييرات في هذه الدورة",
    dayoff_audit_no_changes: "لا توجد تغييرات بعد الاعتماد في هذه الدورة",
    dayoff_audit_cancelled: "إلغاء دي أوف يوم",
    dayoff_audit_by: "بواسطة",
    dayoff_audit_download: "تنزيل السجل",
    dayoff_confirm_all: "اعتماد الكل",
    dayoff_all_already_confirmed: "جميع الموظفين المعروضين معتمدون بالفعل",
    dayoff_confirm_all_done: "تم اعتماد {n} موظف",
    dayoff_lowdays_title: "موظفون لم يكتمل تحديد الدي أوف الأسبوعي",
    dayoff_lowdays_hint: "{n} موظف ينقصهم دي أوف في أسبوع أو أكثر. الاعتماد يتطلب علامة ✓ في كل أسبوع (4 أو 5 أيام).",
    dayoff_days_word: "أيام",
    dayoff_confirm_eligible_only: "اعتماد المكتملين فقط ({n})",
    dayoff_confirm_anyway: "اعتماد الجميع رغم ذلك",
    dayoff_weekly_required: "⚠️ لا يمكن الاعتماد — المحدد {n} أيام دي أوف فقط من أصل {total} مطلوبة. الأسابيع الناقصة: ({weeks}) — عدّل ثم اعتمد",
    dayoff_insufficient_days: "⚠️ لا يمكن الاعتماد — الجدول غير مكتمل: المحدد {n} أيام دي أوف فقط والمطلوب {total} أيام على الأقل (يوم لكل أسبوع)",
    dayoff_insufficient_days_hire: "⚠️ لا يمكن الاعتماد — الموظف باشر العمل بتاريخ {date} والمطلوب له {total} أيام حسب الأسابيع المستحقة، المحدد {n} فقط",
    dayoff_confirmed_with_note: "✅ تم الاعتماد مع ملاحظة: يوجد أسبوع بدون دي أوف ({weeks})",
    dayoff_missing_weeks_label: "أسابيع ناقصة",
    dayoff_supervisor_label: "مشرف",
    dayoff_goto_today: "اليوم الحالي",
    dayoff_sup_code_title: "الرقم الوظيفي للمشرف",
    dayoff_sup_code_saved: "تم حفظ رقم المشرف",
    dayoff_add_employee: "إضافة موظف",
    dayoff_add_name: "اسم الموظف",
    dayoff_add_branch: "الفرع",
    dayoff_add_supervisor: "المشرف",
    dayoff_add_save: "إضافة",
    dayoff_export_person: "موظف معين — الملفين معاً",
    dayoff_add_from_cards: "إضافة موظف (من كروت البلدية)",
    dayoff_export_person_hint: "ابحث بالاسم أو الرقم الوظيفي",
    dayoff_person_modal_title: "تنزيل جدول موظف معين",
    dayoff_person_search_ph: "اكتب الاسم أو الرقم الوظيفي…",
    dayoff_person_type_hint: "ابدأ الكتابة للبحث عن الموظف",
    dayoff_person_no_match: "لا توجد نتائج",
    dayoff_person_no_code: "بدون رقم وظيفي",
    emp_hire_date: "تاريخ التعيين (اختياري)",
    preview_badge: "معاينة",
    hire_date_hint: "عند تحديده وسط الدورة، يُطلب الدي أوف فقط للأسابيع التي تلي تاريخ التعيين",
    dayoff_add_name_required: "اسم الموظف مطلوب",
    dayoff_added: "تمت إضافة الموظف",
    dayoff_dup_error: "الموظف موجود مسبقًا (رقم وظيفي أو إقامة أو جوال مكرر)",
    dayoff_remind_select_all: "تحديد الكل",
    dayoff_remind_selected: "محدد",
    dayoff_remind_select_first: "حدد موظفًا واحدًا على الأقل",
    dayoff_remind_note_label: "ملاحظة للمشرف (اختياري)",
    dayoff_remind_note_ph: "مثال: الرجاء تحديد أيام الدي أوف قبل نهاية الأسبوع",
    dayoff_remind_send: "إرسال تنبيه للمشرف ({n} موظف)",
    dayoff_remind_sent: "تم إرسال التنبيه إلى {n} مشرف",
    dayoff_remind_no_account: "تنبيه: المشرفون التالون بدون حساب دخول فلم يصلهم الإشعار: {names}",
    chooser_logout: "خروج",
    // Supervisor quick dashboard
    welcome_back: "أهلاً بعودتك",
    supervisor_dashboard_subtitle: "تابع موظفيك وشهاداتهم في مكان واحد",
    my_branches: "فروعي",
    expiring_soon_title: "شهادات تقترب من الانتهاء",
    view_all: "عرض الكل",
    no_expiring_soon: "كل شهادات موظفيك سارية ✓",
    all_certs_current: "ما في شيء يقلقك حالياً، أحسنت!",
    expired_short: "متأخر",
    // Audit Log
    nav_audit_log: "سجل التدقيق",
    audit_log_subtitle: "سجلّ كامل لكل الإضافات والتعديلات والحذف",
    audit_search_placeholder: "ابحث باسم الموظف أو المستخدم...",
    audit_filter_entity: "نوع البيانات",
    audit_filter_action: "نوع العملية",
    audit_filter_days: "المدة",
    days_7: "آخر 7 أيام",
    days_30: "آخر 30 يوم",
    days_90: "آخر 90 يوم",
    days_180: "آخر 180 يوم",
    all: "الكل",
    all_area_managers: "كل مدراء المناطق",
    search: "بحث",
    action_create: "إضافة",
    action_update: "تعديل",
    action_delete: "حذف",
    entity_employee: "موظف",
    entity_branch: "فرع",
    entity_admin: "مشرف",
    entity_user: "حساب",
    audit_empty: "لا توجد عمليات مسجّلة في هذه المدة",
    showing_records: "إجمالي {count} عملية",
    audit_detail_title: "تفاصيل العملية",
    entity_name: "اسم العنصر",
    performed_by: "نُفِّذت بواسطة",
    role: "الدور",
    when: "متى",
    area_manager: "مدير المنطقة",
    am_switch_hint: "اختيار مدير المنطقة ينقل المشرف تحت إدارته مباشرة",
    legacy_attachments_title: "مرفقات قديمة بدون تصنيف",
    legacy_attachments_hint: "ملفات تم رفعها قبل تقسيم الأنواع. تقدر تعرضها/تنزّلها/تحذفها وتعيد رفعها في الخانة المناسبة.",
    confirm_delete_area_manager_hard: "⚠️ هل أنت متأكد؟ سيتم حذف الحساب \"{name}\" وكل فروعه ومشرفيه وموظفيه نهائياً. هذا الإجراء لا يمكن التراجع عنه.",

    // Area Managers
    area_managers_subtitle: "إدارة مدراء المناطق وحساباتهم",
    refresh: "تحديث",
    no_area_managers: "لا يوجد مدراء مناطق مسجلين بعد",
    load_failed: "تعذّر تحميل البيانات",
    active: "مفعّل",
    inactive: "موقوف",
    email_verified: "البريد مؤكّد",
    email_unverified: "البريد غير مؤكّد",
    supervisors: "مشرفون",
    employees: "موظفون",
    branches: "الفروع",
    activate: "تفعيل",
    deactivate: "إيقاف",
    delete: "حذف",
    confirm_activate: "هل تريد إعادة تفعيل هذا الحساب؟",
    confirm_deactivate: "هل تريد إيقاف هذا الحساب؟ لن يستطيع الدخول حتى تعيد تفعيله.",
    confirm_approve: "هل تريد اعتماد الحساب \"{name}\"؟ سيتم تفعيله ليستطيع تسجيل الدخول.",
    confirm_verify_email: "هل تريد تأكيد البريد الإلكتروني \"{email}\" يدوياً؟",
    verify_email_manually: "تأكيد البريد يدوياً",
    confirm_delete_area_manager: "هل تريد حذف الحساب \"{name}\"؟ سيتم إيقاف الحساب.",

    // Dashboard
    dashboard_subtitle: "نظرة عامة على حالة الشهادات الصحية والتثقيف",
    total_employees: "إجمالي الموظفين",
    branches_count: "عدد الفروع",
    admins_count: "عدد المشرفين",
    alerts_count: "تنبيهات تحتاج إجراء",
    health_cert_status: "حالة الشهادة الصحية",
    training_status: "حالة التثقيف",
    status_valid: "سارية",
    status_warning: "قاربت",
    status_expired: "منتهية",
    status_missing: "غير مسجلة",

    // Employees
    employees_subtitle: "إدارة بيانات الموظفين وشهاداتهم",
    add_employee: "إضافة موظف",
    add_new_employee: "إضافة موظف جديد",
    edit_employee: "تعديل بيانات الموظف",
    excel_template: "نموذج Excel",
    import_excel: "استيراد Excel",
    export_csv: "تصدير Excel",
    download_blank_template: "تحميل قالب فارغ",
    download_blank_template_hint: "ملف Excel جاهز بقوائم منسدلة للتعبئة",
    upload_filled_file: "رفع ملف Excel للاسترداد",
    upload_filled_file_hint: "بعد تعبئة القالب أو ملف مصدَّر سابقاً",
    search_placeholder: "بحث بالاسم أو الرقم الوظيفي أو الإقامة...",
    all_branches: "كل الفروع",
    all_admins: "كل المشرفين",
    all_statuses: "كل الحالات",
    cert_health_short: "صحية",
    cert_training_short: "تثقيف",
    basic_info: "البيانات الأساسية",
    employee_id: "الرقم الوظيفي",
    name: "الاسم الكامل",
    position: "المنصب",
    iqama_number: "رقم الهوية",
    branch: "الفرع",
    admin: "المشرف",
    select_branch: "— اختر الفرع —",
    select_admin: "— اختر المشرف —",
    health_cert_section: "الشهادة الصحية (تاريخ هجري)",
    training_section: "التثقيف (تاريخ هجري)",
    expiry_date: "تاريخ الانتهاء",
    municipality_card: "كرد البلدية",
    printed_photo: "صورة مطبوعة",
    additional_info: "معلومات إضافية",
    notes: "ملاحظات",
    health_expiry_col: "انتهاء الصحية",
    training_expiry_col: "انتهاء التثقيف",
    health_expiry_hijri: "تاريخ انتهاء الشهادة الصحية (هجري)",
    training_expiry_hijri: "تاريخ انتهاء التثقيف (هجري)",
    employees_count_total: "موظف",
    days_short: "ي",
    delete_emp_confirm: 'أرشفة الموظف "{name}"؟ سيُخفى من القوائم النشطة ويبقى سجله الكامل محفوظاً في إدارة الموظفين',
    name_required: "اسم الموظف مطلوب",
    save_failed: "تعذر الحفظ",
    file_empty: "الملف فارغ",
    no_valid_rows: "لم يتم العثور على سجلات صالحة. تأكد من تطابق أسماء الأعمدة مع النموذج.",
    import_success: "تم استيراد {n} موظف بنجاح",
    import_result: "تمت المعالجة: {total} صف · مضاف: {inserted} · محدث: {updated}",
    import_failed: "تعذر الاستيراد: ",

    // Branches
    branches_subtitle: "إدارة فروع المنشأة",
    add_branch: "إضافة فرع",
    add_new_branch: "إضافة فرع جديد",
    edit_branch: "تعديل الفرع",
    no_branches: "لا توجد فروع. ابدأ بإضافة أول فرع.",
    branch_name: "اسم الفرع *",
    branch_code: "كود الفرع",
    branch_name_placeholder: "مثل: Alsudairi",
    branch_code_placeholder: "مثل: AJD289",
    delete_branch_confirm: "هل أنت متأكد من حذف الفرع؟",
    code_col: "الكود",
    branch_admin: "المشرف المسؤول",
    no_admin_set: "بدون مشرف",
    propagate_info: "سيتم تطبيق المشرف على كل موظفي هذا الفرع",
    assigned_branches: "الفروع المسؤول عنها",
    select_branches_for_admin: "اختر الفروع التي يشرف عليها هذا المشرف",
    no_branches_yet: "لا توجد فروع بعد. أضف الفروع أولاً.",
    save_branches: "حفظ الفروع",
    branches_saved: "تم تحديث الفروع بنجاح",
    branches_assigned_count: "{n} فرع مسؤول عنها",

    // Admins
    admins_subtitle: "إدارة المشرفين المسؤولين عن الموظفين",
    add_admin: "إضافة مشرف",
    add_new_admin: "إضافة مشرف جديد",
    edit_admin: "تعديل المشرف",
    no_admins: "لا يوجد مشرفون. ابدأ بإضافة أول مشرف.",
    admin_name: "اسم المشرف *",
    phone_col: "الجوال",
    admin_name_placeholder: "مثل: Mahdi",
    phone: "رقم الجوال",
    phone_placeholder: "05XXXXXXXX",
    delete_admin_confirm: "هل أنت متأكد من حذف المشرف؟",
    move: "نقل",
    move_to_area: "نقل لمنطقة أخرى",
    move_supervisor_title: "نقل مشرف لمنطقة أخرى",
    move_supervisor_desc: "سيتم نقل المشرف \"{name}\" مع كل فروعه وموظفيه إلى مدير المنطقة المختار.",
    move_supervisor_warning: "⚠️ هذا الإجراء ينقل جميع الفروع والموظفين التابعين لهذا المشرف تحت إدارة مدير المنطقة الجديد. لن تصبح لديك صلاحية على هذه البيانات بعد النقل (إن لم تكن أنت السوبر أدمن).",
    move_target_area_manager: "مدير المنطقة الهدف",
    select_area_manager: "اختر مدير المنطقة",
    confirm_move: "تأكيد النقل",
    move_target_required: "الرجاء اختيار مدير المنطقة الهدف",
    move_admin_done: "تم نقل المشرف \"{name}\" إلى {target} — {branches} فرع و {employees} موظف.",
    move_admin_already: "المشرف \"{name}\" يتبع بالفعل مدير المنطقة المختار.",
    edit_admin_area_manager_help: "يمكنك تغيير مدير المنطقة لهذا المشرف",
    edit_admin_area_manager_warning: "تغيير مدير المنطقة سينقل جميع فروع وموظفي هذا المشرف تلقائياً إلى مدير المنطقة الجديد.",
    move_employee_title: "نقل موظف لمنطقة أخرى",
    move_employee_desc: "سيتم نقل الموظف \"{name}\" إلى إدارة مدير المنطقة المختار. المشرف/الفرع الجديد يمكن تعيينه لاحقاً.",
    move_employee_done: "تم نقل الموظف \"{name}\" إلى {target}.",
    target_supervisor: "المشرف الهدف",
    target_branch: "الفرع الهدف",
    no_supervisor: "بدون مشرف",
    no_branch: "بدون فرع",
    add_admin_cert: "إضافة شهادتي",
    add_admin_cert_hint: "أضف شهادتك الصحية أو شهادة صحية إدارية تحت العمليات",
    admin_branch_label: "الإدارة",
    admin_branch_missing: "فرع الإدارة غير موجود. يتم إنشاؤه تلقائياً — أعد تحميل الصفحة.",
    admin_branch_no_supervisor: "شهادات الإدارة تُدرج تحت مدير المنطقة مباشرة (لا مشرف).",
    cert_owner_label: "لمن هذه الشهادة؟",
    cert_owner_help: "اختر مَن يخص هذا السجل: أنت (مدير المنطقة) أو أحد المشرفين — يظهر السجل في الملف الشخصي للشخص المختار.",
    cert_owner_am: "شهادتي (مدير المنطقة)",
    role_supervisor_short: "مشرف",

    // Hijri picker
    hijri_day: "يوم",
    hijri_month: "شهر",
    hijri_year: "سنة",
    clear_date: "مسح التاريخ",
    hijri_year_suffix: "هـ",

    // Language
    language: "اللغة",
    lang_ar: "عربي",
    lang_en: "English",

    // Alerts
    alerts: "التنبيهات",
    notif_center_title: "مركز التنبيهات",
    notif_center_subtitle: "اضغط على القسم لعرض التفاصيل",
    notifmod_employees: "كروت البلدية",
    notifmod_employees_desc: "الشهادات الصحية والتثقيف والنقل",
    notifmod_licenses: "رخص الفروع",
    notifmod_licenses_desc: "انتهاء رخص الفروع وتحديثاتها",
    notifmod_dayoff: "Day Off MenaMe",
    notifmod_dayoff_desc: "تغييرات وتذكيرات الإجازات الأسبوعية",
    notifmod_empmgmt: "إدارة الموظفين",
    notifmod_empmgmt_desc: "الطلبات والاعتمادات والحركات",
    notifmod_system: "تنبيهات النظام",
    notifmod_system_desc: "تنبيهات عامة من النظام",
    notif_all_read: "لا توجد تنبيهات غير مقروءة ✓",
    notif_tab_active: "النشطة",
    notif_tab_archived: "الأرشيف",
    notif_search_ph: "بحث بالعنوان / الموظف / الفرع...",
    notif_prio_all: "كل الأولويات",
    notif_prio_critical: "حرجة",
    notif_prio_high: "عالية",
    notif_prio_medium: "متوسطة",
    notif_prio_low: "منخفضة",
    notif_days_all: "كل الفترات",
    notif_days_7: "آخر 7 أيام",
    notif_days_30: "آخر 30 يوم",
    notif_days_90: "آخر 90 يوم",
    notif_sort_newest: "الأحدث أولاً",
    notif_sort_oldest: "الأقدم أولاً",
    notif_sort_priority: "حسب الأولوية",
    notif_mark_all_read: "تعليم الكل كمقروء",
    notif_archive_all: "أرشفة الكل",
    notif_archive_all_confirm: "أرشفة جميع تنبيهات هذا القسم؟ (تبقى في الأرشيف ولا تُحذف)",
    notif_export: "تصدير Excel",
    notif_mark_read: "تعليم كمقروء",
    notif_archive: "أرشفة",
    notif_unarchive: "إعادة من الأرشيف",
    notif_open_action: "فتح",
    notif_status_new: "جديد",
    notif_status_read: "مقروء",
    notif_status_actioned: "تم التنفيذ",
    notif_status_archived: "مؤرشف",
    notif_stat_unread: "غير مقروء",
    notif_stat_archived: "الأرشيف",
    notif_empty: "لا توجد تنبيهات في هذا القسم ✓",
    notif_empty_archived: "الأرشيف فارغ",
    notif_load_more: "عرض المزيد",
    notif_approve: "اعتماد",
    notif_reject: "رفض",
    notif_action_done: "تم تنفيذ الإجراء",
    notif_refresh: "تحديث",
    alerts_panel_title: "تنبيهات الشهادات",
    alerts_subtitle: "الشهادات المنتهية والقاربة من الانتهاء",
    no_alerts: "لا توجد تنبيهات. كل الشهادات سارية ✓",
    expired_section: "منتهية",
    warning_section: "قاربت (خلال 30 يوم)",
    warning_section_dyn: "قاربت (خلال {n} يوم)",
    alerts_within_days_label: "نطاق التنبيه:",
    days_short: "يوم",
    // ── Licenses tracker
    licenses_title: "رخص الفروع",
    licenses_subtitle: "متابعة الرخص المهمة لكل فرع (كل نوع بتاريخ انتهائه)",
    licenses_kpi_total: "إجمالي الفروع",
    licenses_kpi_expired: "منتهية",
    licenses_kpi_warning: "قاربت",
    licenses_kpi_missing: "غير مسجّلة",
    license_biz: "رخصة الفرع",
    license_cd: "الدفاع المدني",
    license_biz_hijri: "رخصة الفرع (تاريخ هجري)",
    license_cd_hijri: "رخصة الدفاع المدني (تاريخ هجري)",
    license_biz_image: "صورة رخصة الفرع",
    license_cd_image: "صورة رخصة الدفاع المدني",
    license_search_placeholder: "بحث بالفرع أو رمز الفرع…",
    license_status_all: "كل الحالات",
    license_status_expired: "منتهية",
    license_status_warning: "قاربت",
    license_status_valid: "سارية",
    license_status_missing: "غير مسجّلة",
    license_status_missing_short: "غير مسجّلة",
    license_status_expired_days: "منتهية منذ {n} يوم",
    license_status_soon_days: "تنتهي خلال {n} يوم",
    license_status_valid_days: "سارٍ · {n} يوم",
    license_am_all: "كل مدراء المناطق",
    license_sup_all: "كل المشرفين",
    license_sup_none: "بدون مشرف",
    license_clear_filters: "مسح الفلاتر",
    license_showing_x_of_y: "{x} فرع من أصل {y}",
    license_col_branch: "الفرع",
    license_col_area_manager: "مدير المنطقة",
    license_col_supervisor: "المشرف",
    license_view: "عرض",
    license_upload_image: "رفع صورة الرخصة",
    license_open_image: "فتح الصورة",
    license_confirm_delete_image: "حذف الصورة؟",
    license_confirm_delete_type: "حذف نوع الترخيص \"{name}\"؟ سيتم حذف كل بياناته من الفروع.",
    license_modal_title: "ترخيصات الفرع",
    license_notes_label: "ملاحظات (اختياري)",
    license_notes_placeholder: "أي ملاحظات حول الرخص…",
    license_err_incomplete_date: "أدخل يوم/شهر/سنة كاملة أو اترك الحقل فارغاً كلياً",
    license_err_names_required: "أدخل الاسم بالعربية والإنجليزية",
    license_err_duplicate: "نوع الترخيص موجود مسبقاً",
    // Manage license types (super admin only)
    license_manage_types: "إدارة أنواع الرخص",
    license_manage_help: "يمكنك تعديل مسميات الرخص أو إضافة نوع رخصة جديدة يتتبعها المدراء (متاح للسوبر ادمن فقط).",
    license_name_ar: "الاسم بالعربية",
    license_name_en: "الاسم بالإنجليزية",
    license_add_new: "إضافة أنواع رخص جديدة",
    license_add_hint_multi_rows: "املأ عدة صفوف ثم اضغط \"حفظ الكل\" لإضافتها دفعة واحدة. اضغط \"+ صف آخر\" لإضافة المزيد.",
    license_add_another_row: "صف آخر",
    license_save_all: "حفظ الكل",
    license_add: "إضافة",
    license_builtin_badge: "افتراضي",
    license_export_xlsx: "تنزيل Excel",
    missing_section: "بدون تاريخ انتهاء",
    no_municipality_section: "بدون كرد بلدية",
    no_expiry_label: "لم يُسجل تاريخ انتهاء",
    no_municipality_card_label: "لا يملك كرد البلدية",
    health_cert: "الشهادة الصحية",
    training_cert: "التثقيف",
    days_ago: "منذ {n} يوم",
    days_left: "متبقي {n} يوم",
    days_left_today: "تنتهي اليوم",
    view_employee: "عرض الموظف",
    refresh: "تحديث",
    // Notifications
    email: "البريد الإلكتروني",
    email_help: "لاستلام التنبيهات",
    send_now: "إرسال إيميل الآن",
    sending: "جارٍ الإرسال...",
    notif_sent: "تم إرسال {n} إيميل",
    notif_skipped_no_email: "تم تخطي {n} مشرف (بدون بريد إلكتروني)",
    notif_failed_label: "فشل في إرسال:",
    notif_no_alerts: "لا توجد تنبيهات لإرسالها",
    notif_auto_info: "إيميل تلقائي يومياً في 8 صباحاً (UTC+3)",
    last_run: "آخر إرسال",
    // Vacation
    vacation: "إجازة",
    on_vacation: "في إجازة",
    vacation_section: "🏖️ إجازة",
    cannot_delete_vacation: "لا يمكن حذف فرع الإجازة",
    vacation_no_admin: "الموظف في إجازة - لا حاجة لمشرف",
    // Attachments
    attachments: "المرفقات",
    attachments_subtitle: "صور الشهادات أو ملفات PDF (الحد الأقصى 10MB)",
    upload_file: "رفع ملف",
    uploading: "جارٍ الرفع...",
    no_attachments: "لا توجد مرفقات",
    view_file: "عرض",
    download_file: "تحميل",
    delete_file: "حذف",
    confirm_delete_file: 'حذف المرفق "{name}"؟',
    upload_failed: "تعذر الرفع",
    file_too_large: "حجم الملف يتجاوز 10MB",
    invalid_file_type: "نوع الملف غير مسموح. المسموح: PDF أو صور",
    save_first: "احفظ الموظف أولاً قبل رفع المرفقات",
    // Attachment kinds
    attach_municipality: "صورة كرت البلدية",
    attach_id: "صورة الهوية",
    attach_personal: "الصورة الشخصية",
    employee_phone: "رقم الجوال",
    // Calendar / Daily tracking
    nav_calendar: "التتبع اليومي",
    today_hijri: "اليوم",
    today_label: "اليوم",
    tomorrow_label: "غداً",
    upcoming_expirations: "الانتهاءات القادمة (30 يوم)",
    no_upcoming: "لا توجد انتهاءات في الفترة القادمة 🎉",
    employees_expiring: "موظف",
    upcoming_subtitle: "تتبع الموظفين الذين تنتهي شهاداتهم في كل يوم",
    // Position dropdown
    position_barista: "باريستا",
    position_shift_leader: "شيفت ليدر",
    position_other: "أخرى",
    position_custom_placeholder: "اكتب المنصب",
    // Employee details modal
    employee_details: "بيانات الموظف",
    view_details: "عرض التفاصيل",
    details_basic: "البيانات الأساسية",
    details_work: "بيانات العمل",
    details_certificates: "الشهادات والتثقيف",
    details_attachments: "المرفقات",
    details_no_value: "—",
  },
  en: {
    app_title: "Barn's Tracker",
    app_subtitle: "Employee & branch operations management",
    loading: "Loading...",
    save: "Save",
    saving: "Saving...",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    actions: "Actions",
    confirm_delete: "Are you sure you want to delete?",
    no_results: "No matching results.",
    total: "Total",
    yes: "Yes",
    no: "No",

    login_subtitle: "Sign in with your account to continue",
    username: "Username or Email",
    username_placeholder: "Username or email",
    password: "Password",
    login: "Login",
    logging_in: "Signing in...",
    login_error_generic: "Something went wrong. Please try again",
    no_account: "Don't have an account?",
    have_account: "Already have an account?",
    create_account: "Create Account",
    create_account_title: "Register an Area Manager Account",
    create_account_subtitle: "Create your account to access your management panel",
    register_error_generic: "Registration failed. Please try again",
    show_password: "Show password",
    hide_password: "Hide password",
    forgot_password: "Forgot password?",
    remember_username: "Remember username",
    forgot_password_title: "Forgot Password?",
    forgot_password_subtitle: "Enter your username or email and we'll send a reset link",
    forgot_identifier_label: "Username or Email",
    forgot_identifier_placeholder: "username or name@example.com",
    send_reset_link: "Send Reset Link",
    forgot_sent_title: "Reset Link Sent ✓",
    forgot_sent_msg: "If the account exists, a reset email is on its way — and a Telegram message too if your account is linked to the bot. The link is valid for 1 hour.",
    reset_password_title: "Reset Password",
    reset_password_subtitle: "Choose a new strong password",
    register_success_title: "Account created successfully",
    register_pending_title: "Account pending approval",
    register_pending_msg: "Your registration has been sent to the administrator for approval. You'll be notified by email once your account is activated and you can sign in.",
    pending_approval_badge: "Pending",
    approve: "Approve",
    approve_account: "Approve Account",
    approving: "Approving...",
    approved_success: "Account approved successfully ✅",
    approved_already: "This account is already active",
    approve_failed: "Failed to approve account",
    approve_back_to_login: "Back to login",
    register_success_email_sent: "A confirmation email was sent to {email}. Click the activation link.",
    register_success_no_email: "Account created. Contact the owner to verify your email.",
    redirecting: "Redirecting",
    full_name: "Full Name",
    full_name_placeholder: "Your full name",
    username_hint: "Letters, numbers, . _ - only (3+ chars)",
    email: "Email",
    password_confirm: "Confirm Password",
    pw_check_length: "8+ characters",
    pw_check_letter: "A letter",
    pw_check_digit: "A digit",
    pw_check_symbol: "A symbol (@ # $ ! …)",
    pw_match_ok: "Passwords match ✓",
    pw_match_fail: "Passwords do not match",
    processing: "Processing...",
    verifying_email: "Verifying your email",
    verify_success_title: "Email Verified ✓",
    verify_success_msg: "Your account has been activated.",
    verify_failed: "Verification failed",
    verify_failed_title: "Verification failed",
    verify_missing_token: "Verification token is missing",
    back_to_login: "Back to login",
    footer_tagline: "Barn's Tracker",

    nav_dashboard: "Dashboard",
    menu: "Menu",
    nav_admin_certs: "Admin Certificates",
    admin_certs_subtitle: "Track certificates of area managers and supervisors",
    view_all_employees: "View all employees",
    position_supervisor: "Supervisor",
    position_area_manager: "Area Manager",
    my_health_cert: "My Health Certificate",
    my_health_cert_none: "No health certificate has been recorded in your name yet. Ask your area manager to add one under the Admin branch.",
    add_my_cert_button: "Add my cert",
    edit_my_cert_button: "Edit my cert",
    my_cert_modal_title: "Add / edit your health cert",
    my_cert_modal_help: "Enter your health-cert details — it will appear in your profile and to your area manager & super admin without additional approval. Name:",
    cert_expiry_required: "Health cert expiry (Hijri) is required — format: YYYY-MM-DD",
    hijri_format_hint: "Format: 1447-06-15 (year-month-day)",
    cert_candidates_title: "Certificates in the Admin branch that may belong to you — link one to your account",
    cert_candidates_help: "Tap \"This is my cert\" on the record that belongs to you — it will be linked to your account and shown in your profile automatically.",
    cert_claim_button: "This is my cert",
    days: "days",
    expiring_soon: "Expiring soon",
    valid: "Valid",
    expired: "Expired",
    missing_cert: "Not recorded",
    nav_positions: "Positions",
    positions_subtitle: "Manage the list of available job positions",
    add_position: "Add position",
    edit_position: "Edit position",
    position_name: "Position name",
    position_name_hint: "Enter the name in English (e.g. Store Manager)",
    position_scope: "Where does this position appear?",
    position_scope_hint: "Branches = shows when adding regular branch employees · Admin = shows for Admin-branch entries · All = shows in every case",
    position_name_required: "Position name is required",
    no_positions: "No positions yet",
    default: "Default",
    cannot_delete_default: "Default positions cannot be deleted",
    delete_position_confirm: "Delete the position \"{name}\"?",
    duplicate_found_title: "Notice: a similar record may already exist",
    duplicate_blocked_title: "Cannot save — duplicate data",
    duplicate_blocked_desc: "The Employee ID, Iqama Number, or Mobile is already registered. Check where the original record lives:",
    dup_matched_on: "matched on",
    dup_field_iqama_number: "Iqama Number",
    dup_field_employee_id: "Employee ID",
    dup_field_phone: "Mobile",
    duplicate_branch_code_error: "Branch code \"{code}\" is already used under area manager: {area_manager_name}",
    duplicate_branch_name_error: "Branch name \"{name}\" is already used under area manager: {area_manager_name}",
    duplicate_admin_name_error: "A supervisor named \"{name}\" already exists in your area",
    duplicate_admin_email_error: "Email is already registered for supervisor: {name} · {area_manager_name}",
    duplicate_admin_phone_error: "Phone is already registered for supervisor: {name} · {area_manager_name}",
    close: "Close",
    profile: "Profile",
    nav_employees: "Employees",
    nav_branches: "Branches",
    nav_admins: "Supervisors",
    nav_area_managers: "Area Managers",
    logout: "Logout",
    shortcut_balady: "Verify Municipality Card",
    shortcut_location: "Our Location on Map",
    role_super_admin: "Owner",
    role_area_manager: "Area Manager",
    role_supervisor: "Supervisor",
    nav_profile: "Profile",
    profile_subtitle: "Manage your personal info and password",
    save_profile: "Save Changes",
    profile_saved: "Profile saved successfully",
    save_failed: "Save failed",
    email_change_hint: "Changing email will require re-verification",
    change_password: "Change Password",
    change_password_subtitle: "Choose a strong password with letters, digits, and symbols",
    current_password: "Current Password",
    new_password: "New Password",
    password_changed: "Password changed successfully",
    email_unverified_title: "Your email is not verified",
    email_unverified_msg: "We sent a verification message to {email}. Check your inbox or resend.",
    resend_verification: "Resend verification",
    verification_resent: "Email sent. Check your inbox",
    supervisor_login_create: "Create supervisor login",
    supervisor_login_edit: "Edit supervisor login",
    supervisor_login_hint: "Create a username & password so the supervisor can log in and view only their own employees.",
    create_login: "Create login",
    revoke_login: "Revoke login",
    confirm_revoke_supervisor_login: "Revoke this supervisor's login account?",
    supervisor_login_save_failed: "Failed to save credentials",
    move_branch_area_title: "Move branch to another area",
    move_branch_area_pick_am: "Pick the new area manager",
    move_branch_area_no_sup: "No supervisor for now (assign later)",
    move_branch_area_btn: "Move branch and all its employees",
    move_branch_area_confirm: "Branch \"{branch}\" and ALL its employees will move to {am}'s area, detaching the current supervisor. Continue?",
    move_branch_area_success: "✅ Branch and {count} employees moved — both managers notified",
    move_branch_area_confirm_btn: "Confirm move now",
    move_branch_area_cancel_btn: "Cancel",
    move_branch_area_pending_save_warn: "⚠️ You selected a new area for this branch — the Save button does NOT perform the move. Use the \"Move branch and all its employees\" button below, or clear the manager selection first.",
    dayoff_unconfirm_title: "Unconfirm day-off — {name}",
    dayoff_unconfirm_warn: "The confirmation will be removed immediately, audited and the relevant managers notified. Changes made afterwards will NOT be tracked as edits to a confirmed plan.",
    dayoff_unconfirm_request_warn: "You cannot unconfirm directly — a request with your reason will be sent to the area manager for approval.",
    dayoff_unconfirm_reason_label: "Unconfirm reason",
    dayoff_unconfirm_reason_ph: "Write a clear reason…",
    dayoff_unconfirm_reason_required: "A reason is required to unconfirm",
    dayoff_unconfirm_request_btn: "Send unconfirm request",
    dayoff_unconfirm_direct_btn: "Unconfirm now",
    dayoff_unconfirm_request_sent: "✅ Unconfirm request sent to the area manager",
    dayoff_unconfirm_pending_tip: "An unconfirm request is pending approval for this employee",
    dayoff_unconfirm_requests_title: "Pending unconfirm requests",
    dayoff_unconfirm_req_by: "Requested by",
    dayoff_approve_unconfirm: "Approve & unconfirm",
    dayoff_reject_unconfirm: "Reject",
    dayoff_unconfirm_approved_msg: "Approved — confirmation removed",
    dayoff_unconfirm_rejected_msg: "Request rejected — confirmation kept",
    role_branch_manager: "Branch Manager",
    branch_type_label: "Branch type",
    branch_type_premium_hint: "Premium branch — a Branch Manager can be assigned from Supervisors page → Branch Managers tab",
    bm_tab_title: "Branch Managers (Premium)",
    bm_subtitle: "A branch manager runs ONE Premium branch and its employees only — with the permissions you grant",
    bm_add: "Add branch manager",
    bm_edit_title: "Edit branch manager",
    bm_name: "Name",
    bm_branch: "Branch",
    bm_branch_hint: "Only Premium branches are listed — change the branch type from the Branches page if missing",
    bm_area_manager: "Area manager",
    bm_modules: "Enabled modules",
    bm_empty: "No branch managers yet — add the first one for a Premium branch",
    bm_delete_confirm: "Delete branch manager account {name}? They will no longer be able to log in.",
    bm_perms_title: "Permissions",
    bm_perms_hint: "Enable a module first, then pick detailed permissions — a disabled module is completely hidden from the branch manager",
    bm_mod_employees: "Municipality Cards",
    bm_mod_licenses: "Branch Licenses",
    bm_mod_dayoff: "Day Off",
    bm_mod_empmgmt: "Employee Management",
    bm_perm_emp_view: "View employees",
    bm_perm_emp_add: "Add employee",
    bm_perm_emp_edit: "Edit employee",
    bm_perm_emp_certificates: "Certificates",
    bm_perm_emp_attachments: "Attachments",
    bm_perm_emp_export: "Export",
    bm_perm_lic_view: "View licenses",
    bm_perm_lic_edit: "Edit licenses",
    bm_perm_lic_attachments: "License attachments",
    bm_perm_dayoff_view: "View",
    bm_perm_dayoff_edit: "Edit",
    bm_perm_dayoff_confirm: "Confirm",
    bm_perm_em_view: "View employees",
    bm_perm_em_add: "Add employee",
    bm_perm_em_edit: "Edit",
    bm_perm_em_transfer: "Transfer request",
    bm_perm_em_vacation: "Vacation/Return",
    bm_perm_em_documents: "Documents",
    bm_perm_em_reports: "Reports",
    bm_perm_notif_view: "View notifications",
    email_optional: "Email (optional)",
    status: "Status",
    ss_reset_btn: "Reset password",
    ss_ch_requester_telegram: "Requester Telegram",
    ss_ch_super_admin_telegram: "Super admin Telegram",
    bm_no_login: "Create login",
    bm_creds_title: "Create branch manager login",
    bm_creds_saved: "✅ Login created — the branch manager can now sign in",
    bm_pending_title: "Premium branches without a branch manager",
    bm_pending_hint: "Pick an employee from the branch's staff to assign as branch manager (supervisor will be detached automatically), or press Ignore",
    bm_pending_pick: "— pick a branch employee —",
    bm_pending_assign: "Assign branch manager",
    bm_pending_ignore: "Ignore",
    bm_pending_has_sup: "Currently under a supervisor — will be detached on assignment",
    bm_assigned_ok: "✅ Branch manager assigned and supervisor detached — create their login and set permissions",
    move_branch_area_hint: "Moves the branch and all its employees to the new area and detaches the old supervisor — audited and both managers notified.",
    supervisor_login_created_ok: "✅ Supervisor login account created successfully",
    supervisor_login_updated_ok: "✅ Login credentials updated successfully",
    optional: "optional",
    password_update_placeholder: "Leave blank to keep current password",
    login_as: "Login as",
    login_as_manager: "Sign in as this manager to view their data",
    confirm_impersonate: "You will be logged in as \"{name}\". To switch back, log out and sign in again.",
    // Module chooser (post-login)
    chooser_welcome: "Welcome 👋 Choose your tracker",
    chooser_hint: "You can switch between trackers later from the side menu",
    chooser_click_enter: "Click to enter",
    chooser_module_employees_title: "Employee Health Certificates",
    chooser_module_employees_subtitle: "Health Card · Training · Municipality Card",
    chooser_module_licenses_title: "Branch Licenses",
    chooser_module_licenses_subtitle: "Business License · Civil Defense License",
    chooser_module_dayoff_subtitle: "Track employees' weekly day-off schedule",
    chooser_module_empmgmt_title: "Employee Management",
    chooser_module_empmgmt_subtitle: "Transfers · Promotions · Vacations · Employee Files",
    em_module_name: "Employee Management",
    em_dash_intro: "The main system for managing employees and their job movements — every action goes through approval before it is applied",
    em_phase_note: "Phase 1: initial structure for review — no functionality enabled yet",
    em_placeholder_badge: "Planned",
    em_placeholder_text: "This page is a structural placeholder. The UI + workflow plan will be presented for approval before implementation starts.",
    em_nav_dashboard: "Dashboard",
    em_nav_employees: "Employees",
    em_nav_transfers: "Transfers",
    em_nav_promotions: "Promotions",
    em_nav_vacations: "Vacations",
    em_nav_files: "Employee Files",
    em_nav_approvals: "Pending Approvals",
    em_nav_reports: "Reports",
    em_nav_audit: "Audit Log",
    em_nav_settings: "Settings",
    nav_system_settings: "System Settings",
    ss_title: "System Settings",
    ss_intro: "Standalone super-admin-only section — global system control",
    ss_permissions: "Permissions Management",
    ss_dynamic_fields: "Dynamic Fields",
    ss_system: "System Settings",
    ss_modules: "Module Settings",
    ss_notifications: "Notification Settings",
    ss_general: "General Settings",
    ss_fields_hint: "Yes/No labels shown in each employee's details inside Employee Management (e.g. Uniform, Cap…)",
    ss_digest_email: "Daily email digest",
    ss_digest_telegram: "Daily Telegram digest",
    ss_default_warning: "Default warning days",
    ss_days: "days",
    ss_notif_hint: "Turning a digest off stops the scheduled 8AM daily send for everyone",
    ss_modules_hint: "Hiding a module removes it from the module chooser for all users",
    ss_mod_licenses: "Branch Licenses",
    ss_mod_dayoff: "Day off MenaMe",
    ss_info_area_managers: "Area managers",
    ss_info_supervisors_users: "Supervisor accounts",
    ss_info_supervisors: "Supervisors",
    ss_info_branches: "Branches",
    ss_info_employees: "Employees",
    ss_info_em_requests: "EM requests",
    ss_info_em_fields: "Custom fields",
    ss_info_audit_logs: "Audit logs",
    ss_perm_capability: "Capability",
    perm_view_all: "View all areas",
    perm_manage_ams: "Manage area managers",
    perm_manage_sups: "Manage supervisors",
    perm_manage_branches: "Manage branches",
    perm_add_employees: "Add/edit employees",
    perm_delete_employees: "Delete employees",
    perm_licenses_edit: "Edit branch licenses",
    perm_dayoff: "Day off roster",
    perm_em_approve: "Approve EM requests",
    perm_system_settings: "System settings",
    ss_perms_hint: "Read-only view of current permissions — full control is a future phase",
    ss_perms_edit_hint: "Click a mark to enable or disable a permission — applied immediately for everyone (Super Admin always has full access)",
    perm_em_requests: "Transfer/Promotion/Vacation requests",
    em_settings_super_only: "Module settings (custom fields) are managed by the super admin via System Settings",
    em_load_error: "Failed to load employees data",
    em_search_ph: "Search: name / ID / iqama…",
    em_all_am: "All area managers",
    em_all_mum: "All supervisors",
    em_all_branches: "All branches",
    em_all_companies: "All companies",
    em_all_nats: "All nationalities",
    em_all_positions: "All positions",
    em_col_branch: "BRANCH NAME",
    em_col_name: "TEAM MEMBER NAME",
    em_col_position: "POSITION",
    em_no_matches: "No matching results",
    em_download_btn: "Download Staff Update",
    em_download_done: "File downloaded",
    em_download_error: "Download failed",
    em_import_btn: "Import Staff Update",
    em_import_done: "Imported: {matched} matched · {updated} employees updated · {branches} branches",
    em_import_error: "Import failed",
    em_import_report_title: "Import Report",
    em_import_hint: "Only MISSING data is filled — the system is the master source; existing values are never overwritten and no new employees are created",
    em_import_stat_matched: "Matched",
    em_import_stat_filled: "Fields filled",
    em_import_stat_updated: "Employees updated",
    em_import_stat_branches: "Branches updated",
    em_import_conflicts_title: "Differences NOT merged ({n})",
    em_import_conflicts_hint: "Values differ between system and file — left unchanged, review manually",
    em_import_unmatched_title: "Not found in system ({n})",
    em_import_unmatched_hint: "IDs in the file with no matching employee in your scope — not created, to avoid duplicates",
    em_import_no_issues: "No differences or notes ✓",
    em_conf_emp: "Employee / Branch",
    em_conf_field: "Field",
    em_conf_current: "In system",
    em_conf_file: "In file",
    em_build_title: "Build Area Manager Database",
    em_build_hint: "The file contains employees not in the system. Pick the area manager name (AM column) to auto-create his branches, supervisors and employees — without municipality certificates (added later from Municipality Cards)",
    em_build_select_am: "Area manager name in file (AM)",
    em_build_target_am: "Target area manager account",
    em_build_btn: "Build Database",
    em_build_confirm: "Branches, supervisors and employees will be created for {am} rows from the file. Continue?",
    em_build_rows: "rows",
    em_build_done_title: "Database built — {am}",
    em_build_stat_employees: "Employees created",
    em_build_stat_branches: "Branches created",
    em_build_stat_supervisors: "Supervisors created",
    em_build_stat_skipped: "Rows for other AMs (ignored)",
    em_build_foreign_title: "Already under another area manager ({n})",
    em_build_foreign_hint: "Not moved or duplicated — use transfer requests if needed",
    em_saved: "Saved",
    em_save_error: "Save failed",
    em_trial_note: "Trial mode — all sections work for preview; every action goes through approval before being applied. Tell us about any change or cancellation",
    em_type_transfer: "Transfer",
    em_type_promotion: "Promotion",
    em_type_vacation: "Vacation",
    em_type_vacation_return: "Vacation Return",
    em_type_sup_transfer: "Supervisor Transfer",
    em_req_sup_transfer_btn: "Supervisor transfer",
    em_pick_supervisor: "Select supervisor",
    em_sup_transfer_hint: "Transferring a supervisor moves all their branches and employees to the new Area Manager, reflected automatically in Municipality Cards, Licenses and Day Off",
    em_full_edit_btn: "Edit full data (name/branch/supervisor…)",
    em_staff_fields_title: "Staff Update data (Employee Management)",
    em_transfer_xlsx_btn: "Download transfer form (Excel)",
    em_xlsx_from: "From date",
    em_xlsx_to: "To date",
    em_files_hint: "Click any employee to open their full file: data, timeline, activity log and documents",
    em_former_badge: "Former employee",
    em_show_former: "Former employees",
    em_nav_archive: "Employee Archive",
    em_emp_archive_title: "Employee Archive",
    em_archived_reason: "Archive reason",
    em_archive_reason_prompt: "Archive reason (optional):",
    em_last_branch: "Last branch",
    em_last_sup: "Last supervisor",
    em_filter_label: "Filter",
    em_filter_approved_today: "Approved today",
    em_filter_rejected: "Rejected",
    em_filter_all: "All",
    ss_restore_window: "Archived employee restore window",
    ss_otp_expiry: "Temporary login code (OTP) validity",
    ss_minutes: "min",
    ss_reset_otp: "Reset password",
    ss_otp_confirm: "Send a temporary one-time code (OTP) for {name}? The code goes to the USER's own email/telegram.",
    ss_otp_sent: "✅ Temporary code sent via: {channels}",
    ss_ch_email: "Email",
    ss_ch_telegram: "Telegram",
    ss_ch_admin_email: "Super admin email",
    ss_otp_tg_contact: "Telegram contact link for the user (copy to send them the code directly):",
    acct_mgmt_title: "Account management",
    acct_no_login: "No login account for this supervisor — create one first via the key button in the list",
    ss_convert_title: "Convert to supervisor",
    ss_convert_hint: "If this account was registered as an area manager by mistake, convert it to a supervisor login keeping the same username, email and password — nothing is deleted",
    ss_convert_existing: "Link to an existing supervisor record",
    ss_convert_new_under: "Or create a new supervisor record under area manager",
    ss_convert_btn: "Convert to supervisor",
    ss_convert_confirm: "Convert {name}'s account to supervisor? Login credentials are preserved.",
    ss_convert_done: "✅ Converted to supervisor under {am} — same username & password",
    ss_acc_phone: "Phone",
    ss_acc_telegram: "Telegram",
    ss_acc_tg_linked: "Linked ✓",
    ss_acc_tg_not_linked: "Not linked",
    ss_acc_branches: "Linked branches",
    ss_acc_no_branches: "No linked branches",
    ss_acc_otp_pending: "Active OTP pending",
    fcp_title: "Create a new password",
    fcp_subtitle: "You signed in with a temporary code — set a new password to continue",
    fcp_new_password: "New password",
    fcp_confirm_password: "Confirm new password",
    fcp_submit: "Save & continue",
    fcp_success: "✅ Password changed successfully",
    em_restore: "Restore",
    em_restore_left: "{n} days left to restore",
    em_restore_expired: "Restore window expired",
    em_restore_confirm: "Restore employee {name} back to the active list?",
    em_restored_ok: "✅ Employee restored successfully",
    em_archive_tab_movements: "Movements archive",
    em_archive_tab_former: "Former employees",
    em_former_empty: "No former employees",
    em_former_hint: "An employee can be restored within 30 days of archiving; after that restore is unavailable",
    em_archived_on: "Archived on",
    em_archived_by: "Archived by",
    ss_account_lookup: "Account lookup",
    ss_lookup_placeholder: "Search by email, username or name...",
    ss_lookup_no_results: "No matching accounts",
    ss_orphan_account: "Supervisor record deleted",
    ss_inactive: "Inactive",
    ss_gen_reset_link: "Reset link",
    ss_reset_link_copied: "✅ Link generated & copied — valid for 1 hour",
    ss_reset_link_prompt: "Copy the link and send it to the user:",
    ss_delete_login: "Delete account",
    ss_delete_login_confirm: "Delete login account ({name})? Its email and username will be freed.",
    ss_login_deleted: "✅ Login account deleted",
    ss_linked_supervisor: "Linked supervisor",
    ss_linked_am: "Area manager",
    ss_acc_click_hint: "Click an account name to edit its data and linkages",
    ss_edit_account: "Edit account",
    ss_acc_fullname: "Full name",
    ss_acc_username: "Username",
    ss_acc_email: "Email",
    ss_acc_active: "Account active",
    ss_acc_linked_admin: "Linked supervisor record",
    ss_acc_linked_am: "Linked area manager",
    ss_acc_saved: "✅ Account saved",
    em_timeline: "Timeline",
    em_activity_log: "Activity Log",
    em_no_events: "No events",
    em_by: "By",
    em_ev_hired: "Hired",
    em_ev_branch_change: "Branch change",
    em_ev_supervisor_change: "Supervisor change",
    em_ev_am_change: "Area Manager change",
    em_ev_data_edit: "Data edit",
    em_ev_document_added: "Document added",
    em_ev_archived: "Archived",
    em_field_col: "Field",
    em_old_val: "Before",
    em_new_val: "After",
    em_docs_title: "Employee documents",
    em_doc_category: "Category",
    em_doc_upload: "Upload document",
    em_doc_title_ph: "Document title",
    em_doc_expiry: "Expiry date (optional)",
    em_doc_expiry_short: "Expires",
    em_doc_note_ph: "Note (optional)",
    em_doc_uploaded: "Document uploaded ✅",
    em_doc_deleted: "Document deleted",
    em_doc_delete_confirm: "Delete this document?",
    em_doc_pick_required: "Pick a category and a file first",
    em_doc_new_cat_ph: "New category…",
    em_doc_add_cat: "Add category",
    em_municipal_attachments: "Municipality attachments (read-only)",
    em_no_docs: "No documents",
    em_approve_note_ph: "Approval note (optional)",
    em_approve_confirm: "Confirm approval",
    em_approve_note_label: "Approval note",
    date: "Date",
    download: "Download",
    em_status_pending: "Pending",
    em_status_approved: "Approved",
    em_status_rejected: "Rejected",
    em_col_type: "Type",
    em_col_emp: "Employee",
    em_col_date: "Date",
    em_col_status: "Status",
    em_from: "From",
    em_to: "To",
    em_requested_by: "Requested by",
    em_decided_by: "Decided by",
    em_reject_reason: "Reject reason",
    em_reject_reason_ph: "Write the reject reason…",
    em_approve: "Approve",
    em_reject: "Reject",
    em_send_request: "Send request",
    em_request_sent: "Request sent — pending approval",
    em_transfer_applied: "Transfer applied immediately ✅",
    em_custom_fields: "Custom Fields",
    em_last_data: "Latest employee data",
    em_field_level_critical: "Critical",
    em_field_level_normal: "Normal",
    em_field_level_hint: "If a field is critical and its value is 'No', a critical alert is shown to the area manager until it changes to 'Yes'",
    em_add_employee: "Add Employee",
    em_on_vacation_now: "Currently on vacation",
    em_vacation_view_all: "View all",
    em_vacation_overdue: "Overdue return",
    em_end_vacation_btn: "End vacation & return to branch",
    em_end_vacation_confirm: "End {name}'s vacation and return them to their previous branch? The action will be logged.",
    em_vacation_ended: "Vacation ended — employee returned to branch",
    em_no_vacation_now: "No employees currently on vacation",
    em_archive_employee: "Archive employee",
    em_archive_confirm: "The employee will be removed from active lists and moved to Former Employees, keeping all records and documents. Continue?",
    em_archived_ok: "Employee moved to Former Employees",
    em_manage_fields: "Manage Fields",
    em_no_fields: "No fields yet — the super admin adds them via 'Manage Fields'",
    em_field_name_ph: "Field name (e.g. Uniform)…",
    em_add_field: "Add",
    em_request_error: "Operation failed",
    em_approved_toast: "Approved & applied ✅",
    em_rejected_toast: "Request rejected",
    em_tab_pending: "Pending",
    em_tab_history: "History",
    em_no_requests: "No requests",
    em_pick_employee: "Search employee by name or ID…",
    em_pick_dest_am: "Destination area manager",
    em_pick_dest_mum: "Destination supervisor",
    em_pick_dest_branch: "Destination branch",
    em_new_position: "New position",
    em_start_date: "Vacation start date",
    em_return_date: "Expected return date",
    em_actual_return: "Actual return date",
    em_note_label: "Note",
    em_req_transfer_btn: "Transfer request",
    em_req_promotion_btn: "Promotion request",
    em_req_vacation_btn: "Vacation request",
    em_req_return_btn: "Register return",
    em_approvals_flow_hint: "All requests enter Pending Approvals and are only applied after area manager approval",
    em_approvals_only_am: "Approve/reject is restricted to area managers — you can track your requests here",
    em_archive_title: "Reports — Movements Archive",
    em_all_types: "All types",
    em_archive_download: "Download Archive Excel",
    em_stat_employees: "Employees",
    em_stat_pending: "Pending approvals",
    em_stat_approved_today: "Approved today",
    em_stat_rejected: "Rejected",
    em_stat_on_vacation: "On vacation",
    em_on_vacation_badge: "On vacation",
    em_view_profile: "View employee profile",
    em_profile_pending: "Pending requests",
    em_profile_history: "Movements history",
    em_profile_attachments: "Attachments",
    em_profile_cert: "Health cert (expiry)",
    nav_dayoff: "Day Off Tracker",
    dayoff_subtitle: "Weekly day-off tracking (16th to 15th cycle)",
    dayoff_prev: "Previous cycle",
    dayoff_next: "Next cycle",
    dayoff_current: "Current cycle",
    dayoff_search: "Search employee…",
    dayoff_all_branches: "All branches",
    dayoff_employees_word: "employees",
    dayoff_employee: "Employee",
    dayoff_total: "Total",
    dayoff_hint: "Click a day cell to set the day off, click again to remove it",
    dayoff_no_employees: "No employees found",
    dayoff_load_error: "Failed to load data",
    dayoff_save_error: "Failed to save change",
    dayoff_all_supervisors: "All supervisors",
    dayoff_emp_no: "Emp. No.",
    dayoff_download: "Download Excel",
    dayoff_export_error: "Failed to download file",
    dayoff_pick_month: "Pick a month",
    dayoff_picker_hint: "Picking a month shows the cycle from its 16th to the 15th of the next month",
    dayoff_shift: "Shift",
    dayoff_shift_edit: "Edit shift",
    dayoff_shift_title: "Set employee shift",
    dayoff_shift_from: "Effective from",
    dayoff_shift_from_hint: "If the shift changed mid-cycle, pick the day the new shift started",
    dayoff_shift_whole_cycle: "Apply to the whole cycle (cancels any previous shift change)",
    dayoff_shift_save: "Save shift",
    dayoff_shift_saved: "Shift saved",
    dayoff_shift_unset: "Set shift",
    dayoff_set_shift_first: "Set the employee's shift first before marking day offs",
    dayoff_shift_pick_required: "Choose AM or PM first",
    tg_title: "Telegram Notifications",
    tg_subtitle: "Link your account to receive instant alerts (certs, licenses, day offs)",
    tg_linked: "Linked",
    tg_link_btn: "Link Telegram",
    tg_unlink: "Unlink",
    tg_verify: "Verify Link",
    tg_open_bot: "Open Bot",
    tg_step1: "Press “Open Bot” — Telegram opens on the Barns Tracker bot",
    tg_step2: "Press Start inside the bot",
    tg_step3: "Come back here and press “Verify Link”",
    tg_linked_success: "Linked successfully! A welcome message was sent on Telegram ✅",
    tg_lang_label: "Notification message language",
    transfers_title: "Transfer Requests",
    transfers_incoming: "Incoming (need your approval)",
    transfers_outgoing: "My sent requests",
    transfers_none: "No requests",
    transfer_approve: "Approve",
    transfer_reject: "Reject",
    transfer_from: "From area",
    transfer_to: "To area",
    transfer_by: "Requested by",
    transfer_status_approved: "Approved",
    transfer_status_rejected: "Rejected",
    transfer_status_pending: "Pending approval",
    transfer_request_sent: "Transfer request sent — awaiting destination area manager approval",
    transfer_approved_toast: "Transfer approved and employee moved",
    transfer_rejected_toast: "Transfer request rejected",
    transfer_needs_approval_hint: "Transfers to another area require the destination area manager's approval — they will be notified",
    dayoff_export_new_emps: "New employees — both files",
    dayoff_export_new_emps_hint: "Only those added during the current cycle",
    trial_badge: "Trial",
    activity_last_seen: "Last seen",
    activity_title: "Login activity",
    activity_details: "Login & session details",
    activity_online_now: "Online now 🟢",
    activity_mins_ago: "{n} min ago",
    activity_hours_ago: "{n}h ago",
    activity_week_engagement: "Weekly engagement",
    activity_days_count: "{n} login days",
    activity_month_engagement: "Monthly engagement (last 30 days)",
    activity_download: "Download report",
    em_supervisors_card_hint: "Supervisor details & login activity",
    em_days_count: "{n} days",
    em_days_selected: "Vacation length: {n} days",
    em_days_invalid: "⚠️ Return date must be after the start date",
    em_vac_duration: "Duration: {n} days",
    em_vac_remaining: "{n} days left",
    ntype_all: "All alert types",
    ntype_cert_missing_health: "No health certificate",
    ntype_cert_expired_health: "Health certificate expired",
    ntype_cert_expiring_health: "Health certificate expiring soon",
    ntype_cert_missing_training: "No training certificate",
    ntype_cert_expired_training: "Training expired",
    ntype_cert_expiring_training: "Training expiring soon",
    ntype_no_municipality_card: "No municipality card",
    ntype_missing_data: "Missing data",
    ntype_transfer_request: "Transfer request",
    ntype_transfer_result: "Transfer result",
    ntype_license_expired_all: "License expired (all kinds)",
    ntype_license_expiring_all: "License expiring soon (all kinds)",
    ntype_license_business: "Business license",
    ntype_license_civil_defense: "Civil defense license",
    ntype_dayoff_change: "Change after confirmation",
    ntype_dayoff_confirm_note: "Confirmed with note (missing week)",
    ntype_dayoff_reminder: "Confirmation reminder",
    ntype_dayoff_new_employee: "New employee",
    ntype_em_request_pending: "Pending approval request",
    ntype_em_request_result: "Request result (approved/rejected)",
    ntype_critical_field: "Critical field",
    ntype_vacation_return_soon: "Vacation return soon",
    ntype_vacation_overdue: "Vacation return overdue",
    honor_board_title: "Honor board — top engagement this month",
    honor_month_pct: "{n}% engagement",
    honor_tier_gold: "Gold",
    honor_tier_silver: "Silver",
    honor_tier_bronze: "Bronze",
    honor_score: "Score: {n}%",
    honor_breakdown: "Login {login}% · Interaction {interact}%",
    honor_my_rank: "Your rank: #{rank} of {total} 💪",
    back_to_dashboard: "Back to dashboard",
    back_to_sections: "Back to sections",
    sections_label: "Sections",
    activity_sessions: "Recent sessions (login time · duration)",
    dayoff_cancel: "Cancel",
    dayoff_changes_download: "Changes file",
    dayoff_changed_from: "Day off changed — was on {from}",
    dayoff_change_marked: "Change recorded: from {from} to {to}",
    dayoff_export_done: "Both files downloaded",
    dayoff_export_file1: "File 1",
    dayoff_export_file2: "File 2",
    dayoff_export_both: "Download both files",
    dayoff_export_changes_only: "Changes only",
    dayoff_export_changes_only_hint: "Roster-format file with only the changed days (new then old)",
    dayoff_month_end: "end of month",
    dayoff_confirm_tip: "Confirm this employee's day offs — later changes get a red mark",
    dayoff_confirmed_tip: "Confirmed — click to unconfirm",
    dayoff_confirmed_msg: "Day offs confirmed",
    dayoff_unconfirmed_msg: "Confirmation removed",
    dayoff_audit: "Audit Log",
    dayoff_audit_confirmed: "Confirmed",
    dayoff_audit_unconfirmed: "Not confirmed",
    dayoff_audit_unconfirmed_title: "Employees without supervisor confirmation",
    dayoff_audit_all_confirmed: "All employees confirmed for this cycle",
    dayoff_audit_changes_title: "Changes in this cycle",
    dayoff_audit_no_changes: "No post-confirmation changes in this cycle",
    dayoff_audit_cancelled: "Cancelled day off on",
    dayoff_audit_by: "by",
    dayoff_audit_download: "Download log",
    dayoff_confirm_all: "Confirm all",
    dayoff_all_already_confirmed: "All shown employees are already confirmed",
    dayoff_confirm_all_done: "{n} employees confirmed",
    dayoff_lowdays_title: "Employees with incomplete weekly day offs",
    dayoff_lowdays_hint: "{n} employees are missing a day off in one or more weeks. Confirmation requires a ✓ in every week (4 or 5 days).",
    dayoff_days_word: "days",
    dayoff_confirm_eligible_only: "Confirm complete only ({n})",
    dayoff_confirm_anyway: "Confirm everyone anyway",
    dayoff_weekly_required: "⚠️ Cannot confirm — only {n} day offs set out of {total} required. Missing weeks: ({weeks}) — fix then confirm",
    dayoff_insufficient_days: "⚠️ Cannot confirm — schedule incomplete: only {n} day offs set, at least {total} required (one per week)",
    dayoff_insufficient_days_hire: "⚠️ Cannot confirm — employee started on {date}; {total} day offs required for the entitled weeks, only {n} set",
    dayoff_confirmed_with_note: "✅ Confirmed with a note: a week has no day off ({weeks})",
    dayoff_missing_weeks_label: "Missing weeks",
    dayoff_supervisor_label: "Supervisor",
    dayoff_goto_today: "Today",
    dayoff_sup_code_title: "Supervisor employee number",
    dayoff_sup_code_saved: "Supervisor number saved",
    dayoff_add_employee: "Add employee",
    dayoff_add_name: "Employee name",
    dayoff_add_branch: "Branch",
    dayoff_add_supervisor: "Supervisor",
    dayoff_add_save: "Add",
    dayoff_export_person: "Specific employee — both files",
    dayoff_add_from_cards: "Add employee (via Municipality Cards)",
    dayoff_export_person_hint: "Search by name or employee number",
    dayoff_person_modal_title: "Download one employee's roster",
    dayoff_person_search_ph: "Type a name or employee number…",
    dayoff_person_type_hint: "Start typing to search",
    dayoff_person_no_match: "No matches",
    dayoff_person_no_code: "No employee number",
    emp_hire_date: "Hire Date (optional)",
    preview_badge: "Preview",
    hire_date_hint: "If set mid-cycle, day offs are only required for weeks after the hire date",
    dayoff_add_name_required: "Employee name is required",
    dayoff_added: "Employee added",
    dayoff_dup_error: "Employee already exists (duplicate number, iqama or phone)",
    dayoff_remind_select_all: "Select all",
    dayoff_remind_selected: "selected",
    dayoff_remind_select_first: "Select at least one employee",
    dayoff_remind_note_label: "General note for all selected employees (optional)",
    dayoff_remind_emp_note_ph: "Note specific to this employee (optional)…",
    dayoff_remind_note_ph: "e.g. Please set the day offs before the end of the week",
    dayoff_remind_send: "Send alert to supervisor ({n} employees)",
    dayoff_remind_sent: "Alert sent to {n} supervisors",
    dayoff_remind_no_account: "Warning: these supervisors have no login account so they weren't notified: {names}",
    chooser_logout: "Logout",
    welcome_back: "Welcome back",
    supervisor_dashboard_subtitle: "Track your employees and their certificates in one place",
    my_branches: "My branches",
    expiring_soon_title: "Certificates Expiring Soon",
    view_all: "View all",
    no_expiring_soon: "All your employees' certificates are current ✓",
    all_certs_current: "Nothing to worry about right now — great work!",
    expired_short: "overdue",
    nav_audit_log: "Audit Log",
    audit_log_subtitle: "Full history of all adds, edits, and deletes",
    audit_search_placeholder: "Search by employee or user...",
    audit_filter_entity: "Entity",
    audit_filter_action: "Action",
    audit_filter_days: "Period",
    days_7: "Last 7 days",
    days_30: "Last 30 days",
    days_90: "Last 90 days",
    days_180: "Last 180 days",
    all: "All",
    all_area_managers: "All Area Managers",
    search: "Search",
    action_create: "Create",
    action_update: "Edit",
    action_delete: "Delete",
    entity_employee: "Employee",
    entity_branch: "Branch",
    entity_admin: "Supervisor",
    entity_user: "Account",
    audit_empty: "No operations logged in this period",
    showing_records: "{count} record(s)",
    audit_detail_title: "Operation Details",
    entity_name: "Entity name",
    performed_by: "Performed by",
    role: "Role",
    when: "When",
    area_manager: "Area manager",
    am_switch_hint: "Picking an area manager moves the supervisor directly under them",
    legacy_attachments_title: "Legacy attachments (uncategorized)",
    legacy_attachments_hint: "Files uploaded before slot categories existed. You can view/download/delete them and re-upload to the correct slot.",
    confirm_delete_area_manager_hard: "⚠️ Are you sure? This will PERMANENTLY delete \"{name}\" and ALL their branches, supervisors, and employees. This cannot be undone.",

    area_managers_subtitle: "Manage area managers and their accounts",
    refresh: "Refresh",
    no_area_managers: "No area managers registered yet",
    load_failed: "Failed to load data",
    active: "Active",
    inactive: "Suspended",
    email_verified: "Email verified",
    email_unverified: "Email unverified",
    supervisors: "Supervisors",
    employees: "Employees",
    branches: "Branches",
    activate: "Activate",
    deactivate: "Deactivate",
    delete: "Delete",
    confirm_activate: "Reactivate this account?",
    confirm_deactivate: "Suspend this account? They will not be able to sign in until you reactivate.",
    confirm_approve: "Approve the account \"{name}\"? This will activate them and allow them to sign in.",
    confirm_verify_email: "Manually verify the email \"{email}\"?",
    verify_email_manually: "Mark email as verified",
    confirm_delete_area_manager: "Delete account \"{name}\"? The account will be suspended.",

    dashboard_subtitle: "Overview of health certificates & training status",
    total_employees: "Total Employees",
    branches_count: "Branches",
    admins_count: "Supervisors",
    alerts_count: "Alerts requiring action",
    health_cert_status: "Health Certificate Status",
    training_status: "Training Status",
    status_valid: "Valid",
    status_warning: "Expiring Soon",
    status_expired: "Expired",
    status_missing: "Not Registered",

    employees_subtitle: "Manage employee records and certificates",
    add_employee: "Add Employee",
    add_new_employee: "Add New Employee",
    edit_employee: "Edit Employee",
    excel_template: "Excel Template",
    import_excel: "Import Excel",
    export_csv: "Export Excel",
    download_blank_template: "Download blank template",
    download_blank_template_hint: "Ready-to-fill Excel with dropdown lists",
    upload_filled_file: "Upload filled file",
    upload_filled_file_hint: "After filling the template or a previously exported file",
    search_placeholder: "Search by name, employee ID, or iqama...",
    all_branches: "All branches",
    all_admins: "All supervisors",
    all_statuses: "All statuses",
    cert_health_short: "Health",
    cert_training_short: "Training",
    basic_info: "Basic Information",
    employee_id: "Employee ID",
    name: "Full Name",
    position: "Position",
    iqama_number: "ID Number",
    branch: "Branch",
    admin: "Supervisor",
    select_branch: "— Select branch —",
    select_admin: "— Select supervisor —",
    health_cert_section: "Health Certificate (Hijri date)",
    training_section: "Training (Hijri date)",
    expiry_date: "Expiry Date",
    municipality_card: "Municipality Card",
    printed_photo: "Printed Photo",
    additional_info: "Additional Info",
    notes: "Notes",
    health_expiry_col: "Health Expiry",
    training_expiry_col: "Training Expiry",
    health_expiry_hijri: "Health cert expiry (Hijri)",
    training_expiry_hijri: "Training expiry (Hijri)",
    employees_count_total: "employee(s)",
    days_short: "d",
    delete_emp_confirm: 'Archive employee "{name}"? Hidden from active lists — the full record stays in Employee Management',
    name_required: "Employee name is required",
    save_failed: "Unable to save",
    file_empty: "File is empty",
    no_valid_rows: "No valid records found. Make sure column names match the template.",
    import_success: "Successfully imported {n} employee(s)",
    import_result: "Processed {total} rows · Added: {inserted} · Updated: {updated}",
    import_failed: "Import failed: ",

    branches_subtitle: "Manage organization branches",
    add_branch: "Add Branch",
    add_new_branch: "Add New Branch",
    edit_branch: "Edit Branch",
    no_branches: "No branches yet. Start by adding your first branch.",
    branch_name: "Branch Name *",
    branch_code: "Branch Code",
    branch_name_placeholder: "e.g., Alsudairi",
    branch_code_placeholder: "e.g., AJD289",
    delete_branch_confirm: "Are you sure you want to delete this branch?",
    code_col: "Code",
    branch_admin: "Responsible Supervisor",
    no_admin_set: "Unassigned",
    propagate_info: "This will be applied to all employees in this branch",
    assigned_branches: "Branches under supervision",
    select_branches_for_admin: "Select branches supervised by this person",
    no_branches_yet: "No branches yet. Add branches first.",
    save_branches: "Save branches",
    branches_saved: "Branches updated successfully",
    branches_assigned_count: "Supervising {n} branch(es)",

    admins_subtitle: "Manage supervisors responsible for employees",
    add_admin: "Add Supervisor",
    add_new_admin: "Add New Supervisor",
    edit_admin: "Edit Supervisor",
    no_admins: "No supervisors yet. Start by adding your first supervisor.",
    admin_name: "Supervisor Name *",
    phone_col: "Phone",
    admin_name_placeholder: "e.g., Mahdi",
    phone: "Phone",
    phone_placeholder: "05XXXXXXXX",
    delete_admin_confirm: "Are you sure you want to delete this supervisor?",
    move: "Move",
    move_to_area: "Move to another area",
    move_supervisor_title: "Move supervisor to another area",
    move_supervisor_desc: "Supervisor \"{name}\" along with all their branches and employees will be reassigned to the selected Area Manager.",
    move_supervisor_warning: "⚠️ This will transfer ownership of all branches and employees under this supervisor to the new Area Manager. You will lose access to this data after the move (unless you are Super Admin).",
    move_target_area_manager: "Target Area Manager",
    select_area_manager: "Select an area manager",
    confirm_move: "Confirm move",
    move_target_required: "Please select a target area manager",
    move_admin_done: "Moved supervisor \"{name}\" to {target} — {branches} branches, {employees} employees.",
    move_admin_already: "Supervisor \"{name}\" is already under the selected area manager.",
    edit_admin_area_manager_help: "you can change the area manager for this supervisor",
    edit_admin_area_manager_warning: "Changing the area manager will automatically move all this supervisor's branches and employees to the new area manager.",
    move_employee_title: "Move employee to another area",
    move_employee_desc: "Employee \"{name}\" will be reassigned under the selected Area Manager. Branch/supervisor can be set later.",
    move_employee_done: "Moved employee \"{name}\" to {target}.",
    target_supervisor: "Target Supervisor",
    target_branch: "Target Branch",
    no_supervisor: "No supervisor",
    no_branch: "No branch",
    add_admin_cert: "Add My Cert",
    add_admin_cert_hint: "Add your own health certificate or an admin cert under Operations",
    admin_branch_label: "Admin",
    admin_branch_missing: "Admin branch not found. It is auto-created — please reload the page.",
    admin_branch_no_supervisor: "Admin certificates are listed directly under the area manager (no supervisor).",
    cert_owner_label: "Certificate owner",
    cert_owner_help: "Pick who this record belongs to: you (Area Manager) or one of your supervisors — it will show up in that person's Profile.",
    cert_owner_am: "My cert (Area Manager)",
    role_supervisor_short: "supervisor",

    hijri_day: "Day",
    hijri_month: "Month",
    hijri_year: "Year",
    clear_date: "Clear date",
    hijri_year_suffix: "H",

    language: "Language",
    lang_ar: "عربي",
    lang_en: "English",

    // Alerts
    alerts: "Alerts",
    notif_center_title: "Notification Center",
    notif_center_subtitle: "Tap a module to view details",
    notifmod_employees: "Municipality Cards",
    notifmod_employees_desc: "Health & training certificates and transfers",
    notifmod_licenses: "Branch Licenses",
    notifmod_licenses_desc: "Branch license expiries and updates",
    notifmod_dayoff: "Day Off MenaMe",
    notifmod_dayoff_desc: "Weekly day-off changes and reminders",
    notifmod_empmgmt: "Employee Management",
    notifmod_empmgmt_desc: "Requests, approvals and movements",
    notifmod_system: "System Notifications",
    notifmod_system_desc: "General system notifications",
    notif_all_read: "No unread notifications ✓",
    notif_tab_active: "Active",
    notif_tab_archived: "Archive",
    notif_search_ph: "Search title / employee / branch...",
    notif_prio_all: "All priorities",
    notif_prio_critical: "Critical",
    notif_prio_high: "High",
    notif_prio_medium: "Medium",
    notif_prio_low: "Low",
    notif_days_all: "All time",
    notif_days_7: "Last 7 days",
    notif_days_30: "Last 30 days",
    notif_days_90: "Last 90 days",
    notif_sort_newest: "Newest first",
    notif_sort_oldest: "Oldest first",
    notif_sort_priority: "By priority",
    notif_mark_all_read: "Mark all as read",
    notif_archive_all: "Archive all",
    notif_archive_all_confirm: "Archive all notifications in this module? (kept in archive, never deleted)",
    notif_export: "Export Excel",
    notif_mark_read: "Mark as read",
    notif_archive: "Archive",
    notif_unarchive: "Restore from archive",
    notif_open_action: "Open",
    notif_status_new: "New",
    notif_status_read: "Read",
    notif_status_actioned: "Actioned",
    notif_status_archived: "Archived",
    notif_stat_unread: "Unread",
    notif_stat_archived: "Archive",
    notif_empty: "No notifications in this module ✓",
    notif_empty_archived: "Archive is empty",
    notif_load_more: "Load more",
    notif_approve: "Approve",
    notif_reject: "Reject",
    notif_action_done: "Action completed",
    notif_refresh: "Refresh",
    alerts_panel_title: "Certificate Alerts",
    alerts_subtitle: "Expired and soon-to-expire certificates",
    no_alerts: "No alerts. All certificates are valid ✓",
    expired_section: "Expired",
    warning_section: "Expiring (within 30 days)",
    warning_section_dyn: "Expiring (within {n} days)",
    alerts_within_days_label: "Alert window:",
    days_short: "d",
    // ── Licenses tracker
    licenses_title: "Branch Licenses",
    licenses_subtitle: "Track important licenses per branch (each type with its expiry date)",
    licenses_kpi_total: "Total branches",
    licenses_kpi_expired: "Expired",
    licenses_kpi_warning: "Expiring soon",
    licenses_kpi_missing: "Not recorded",
    license_biz: "Business license",
    license_cd: "Civil defense",
    license_biz_hijri: "Business license (Hijri date)",
    license_cd_hijri: "Civil defense license (Hijri date)",
    license_biz_image: "Business license image",
    license_cd_image: "Civil defense license image",
    license_search_placeholder: "Search by branch name or code…",
    license_status_all: "All statuses",
    license_status_expired: "Expired",
    license_status_warning: "Expiring soon",
    license_status_valid: "Valid",
    license_status_missing: "Not recorded",
    license_status_missing_short: "Not recorded",
    license_status_expired_days: "Expired {n}d ago",
    license_status_soon_days: "Expires in {n}d",
    license_status_valid_days: "Valid · {n}d",
    license_am_all: "All area managers",
    license_sup_all: "All supervisors",
    license_sup_none: "No supervisor",
    license_clear_filters: "Clear filters",
    license_showing_x_of_y: "{x} of {y} branches",
    license_col_branch: "Branch",
    license_col_area_manager: "Area manager",
    license_col_supervisor: "Supervisor",
    license_view: "View",
    license_upload_image: "Upload license image",
    license_open_image: "Open image",
    license_confirm_delete_image: "Delete image?",
    license_confirm_delete_type: "Delete license type \"{name}\"? All its data across branches will be removed.",
    license_modal_title: "Branch licenses",
    license_notes_label: "Notes (optional)",
    license_notes_placeholder: "Any notes about these licenses…",
    license_err_incomplete_date: "Enter full day/month/year or leave the field empty",
    license_err_names_required: "Enter both Arabic and English names",
    license_err_duplicate: "This license type already exists",
    license_manage_types: "Manage license types",
    license_manage_help: "Rename existing licenses or add a new type that managers must track (super-admin only).",
    license_name_ar: "Arabic name",
    license_name_en: "English name",
    license_add_new: "Add a new license type",
    license_add_hint_multi: "You can add several types one after another — every click on \"Add\" saves the type immediately and clears the fields for the next one.",
    license_add: "Add",
    license_builtin_badge: "default · builtin",
    missing_section: "Missing expiry date",
    no_municipality_section: "No municipality card",
    no_expiry_label: "No expiry date set",
    no_municipality_card_label: "Missing municipality card",
    health_cert: "Health Certificate",
    training_cert: "Training",
    days_ago: "{n} day(s) ago",
    days_left: "{n} day(s) left",
    days_left_today: "Expires today",
    view_employee: "View employee",
    refresh: "Refresh",
    // Notifications
    email: "Email",
    email_help: "To receive alerts",
    send_now: "Send email now",
    sending: "Sending...",
    notif_sent: "{n} email(s) sent",
    notif_skipped_no_email: "{n} supervisor(s) skipped (no email)",
    notif_failed_label: "Failed to send:",
    notif_no_alerts: "No alerts to send",
    notif_auto_info: "Auto-sent daily at 8 AM (UTC+3)",
    last_run: "Last sent",
    // Vacation
    vacation: "Vacation",
    on_vacation: "On Vacation",
    vacation_section: "🏖️ Vacation",
    cannot_delete_vacation: "Cannot delete the Vacation branch",
    vacation_no_admin: "Employee on vacation - no supervisor needed",
    // Attachments
    attachments: "Attachments",
    attachments_subtitle: "Certificate photos or PDF files (max 10MB)",
    upload_file: "Upload file",
    uploading: "Uploading...",
    no_attachments: "No attachments",
    view_file: "View",
    download_file: "Download",
    delete_file: "Delete",
    confirm_delete_file: 'Delete attachment "{name}"?',
    upload_failed: "Upload failed",
    file_too_large: "File exceeds 10MB",
    invalid_file_type: "Invalid file type. Allowed: PDF or images",
    save_first: "Save the employee first before adding attachments",
    // Attachment kinds
    attach_municipality: "Municipality Card Photo",
    attach_id: "ID Photo",
    attach_personal: "Personal Photo",
    employee_phone: "Phone Number",
    // Calendar / Daily tracking
    nav_calendar: "Daily Tracking",
    today_hijri: "Today",
    today_label: "Today",
    tomorrow_label: "Tomorrow",
    upcoming_expirations: "Upcoming Expirations (30 days)",
    no_upcoming: "No upcoming expirations 🎉",
    employees_expiring: "employee(s)",
    upcoming_subtitle: "Track employees whose certificates expire each day",
    // Position dropdown
    position_barista: "Barista",
    position_shift_leader: "Shift Leader",
    position_other: "Other",
    position_custom_placeholder: "Type position",
    // Employee details modal
    employee_details: "Employee Details",
    view_details: "View Details",
    details_basic: "Basic Info",
    details_work: "Work Info",
    details_certificates: "Certificates & Training",
    details_attachments: "Attachments",
    details_no_value: "—",
  },
};

export const HIJRI_MONTHS_I18N = {
  ar: [
    "محرم", "صفر", "ربيع الأول", "ربيع الآخر",
    "جمادى الأولى", "جمادى الآخرة", "رجب", "شعبان",
    "رمضان", "شوال", "ذو القعدة", "ذو الحجة",
  ],
  en: [
    "Muharram", "Safar", "Rabi' I", "Rabi' II",
    "Jumada I", "Jumada II", "Rajab", "Sha'ban",
    "Ramadan", "Shawwal", "Dhu al-Qi'dah", "Dhu al-Hijjah",
  ],
};

const LangContext = createContext({ lang: "ar", setLang: () => {}, t: (k) => k });

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hct_lang") || "ar");

  useEffect(() => {
    localStorage.setItem("hct_lang", lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = lang === "ar" ? "rtl" : "ltr";
  }, [lang]);

  const t = (key, vars) => {
    let s = (translations[lang] && translations[lang][key]) || translations.ar[key] || key;
    if (vars) {
      Object.keys(vars).forEach((k) => {
        s = s.replace(`{${k}}`, vars[k]);
      });
    }
    return s;
  };

  return (
    <LangContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LangContext.Provider>
  );
}

export function useT() {
  return useContext(LangContext);
}
